/*
 * Design Studio — Custom Design Wrap product (Phase 0: size selection, pricing, add-to-cart).
 * The on-canvas editor (Fabric.js) and per-club cut lines arrive in later phases.
 *
 * Isolation: this controls only #design-studio-root and ds-* elements. It does NOT touch any
 * id the legacy custom-line-item-properties.js looks for, so that script self-skips here.
 */
(function () {
  'use strict';

  var PLACEHOLDER = 'REPLACE_ME'; // sentinel until the hidden pricing products are created
  var WIZARD_KEY = 'ds-wizard-seen'; // localStorage flag: first-visit walkthrough already shown

  /* ---- shared element geometry (one source for both the canvas shape and its dropdown thumbnail) ---- */
  function regPoly(n, r, startDeg) {
    var pts = [], a0 = (startDeg == null ? -90 : startDeg) * Math.PI / 180;
    for (var i = 0; i < n; i++) { var a = a0 + i * 2 * Math.PI / n; pts.push({ x: r + r * Math.cos(a), y: r + r * Math.sin(a) }); }
    return pts;
  }
  function starPoints(spikes, outer, inner) {
    var pts = [], step = Math.PI / spikes, a = -Math.PI / 2;
    for (var i = 0; i < spikes * 2; i++) { var rad = (i % 2 === 0) ? outer : inner; pts.push({ x: outer + rad * Math.cos(a), y: outer + rad * Math.sin(a) }); a += step; }
    return pts;
  }
  function scallopPath(r, n) {
    var pts = [], i;
    for (i = 0; i < n; i++) { var a = i * 2 * Math.PI / n - Math.PI / 2; pts.push([r + r * Math.cos(a), r + r * Math.sin(a)]); }
    var ar = (r * Math.sin(Math.PI / n)).toFixed(1);
    var d = 'M ' + pts[0][0].toFixed(1) + ' ' + pts[0][1].toFixed(1);
    for (i = 1; i <= n; i++) { var p = pts[i % n]; d += ' A ' + ar + ' ' + ar + ' 0 0 1 ' + p[0].toFixed(1) + ' ' + p[1].toFixed(1); }
    return d + ' Z';
  }
  function polyBox(points) {
    var xs = points.map(function (p) { return p.x; }), ys = points.map(function (p) { return p.y; });
    var minx = Math.min.apply(null, xs), miny = Math.min.apply(null, ys);
    return [minx, miny, Math.max.apply(null, xs) - minx, Math.max.apply(null, ys) - miny];
  }
  function elementGeometry(kind) {
    var p;
    switch (kind) {
      case 'circle': return { type: 'circle', cx: 45, cy: 45, r: 45, box: [0, 0, 90, 90] };
      case 'oval': return { type: 'ellipse', cx: 60, cy: 38, rx: 60, ry: 38, box: [0, 0, 120, 76] };
      case 'trapezoid': p = [{ x: 22, y: 0 }, { x: 78, y: 0 }, { x: 100, y: 60 }, { x: 0, y: 60 }]; return { type: 'poly', points: p, box: polyBox(p) };
      case 'pentagon': p = regPoly(5, 50, -90); return { type: 'poly', points: p, box: polyBox(p) };
      case 'hexagon': p = regPoly(6, 50, -90); return { type: 'poly', points: p, box: polyBox(p) };
      case 'octagon': p = regPoly(8, 50, -112.5); return { type: 'poly', points: p, box: polyBox(p) };
      case 'triangle-eq': p = regPoly(3, 50, -90); return { type: 'poly', points: p, box: polyBox(p) };
      case 'triangle-iso': p = [{ x: 50, y: 0 }, { x: 95, y: 90 }, { x: 5, y: 90 }]; return { type: 'poly', points: p, box: polyBox(p) };
      case 'triangle-right': p = [{ x: 0, y: 0 }, { x: 0, y: 80 }, { x: 80, y: 80 }]; return { type: 'poly', points: p, box: polyBox(p) };
      case 'chevron': p = [{ x: 0, y: 0 }, { x: 42, y: 0 }, { x: 84, y: 40 }, { x: 42, y: 80 }, { x: 0, y: 80 }, { x: 42, y: 40 }]; return { type: 'poly', points: p, box: polyBox(p) };
      case 'arrow': p = [{ x: 0, y: 24 }, { x: 60, y: 24 }, { x: 60, y: 0 }, { x: 100, y: 40 }, { x: 60, y: 80 }, { x: 60, y: 56 }, { x: 0, y: 56 }]; return { type: 'poly', points: p, box: polyBox(p) };
      case 'arrow-double': p = [{ x: 0, y: 40 }, { x: 30, y: 8 }, { x: 30, y: 26 }, { x: 90, y: 26 }, { x: 90, y: 8 }, { x: 120, y: 40 }, { x: 90, y: 72 }, { x: 90, y: 54 }, { x: 30, y: 54 }, { x: 30, y: 72 }]; return { type: 'poly', points: p, box: polyBox(p) };
      case 'banner': p = [{ x: 0, y: 0 }, { x: 120, y: 0 }, { x: 104, y: 25 }, { x: 120, y: 50 }, { x: 0, y: 50 }, { x: 16, y: 25 }]; return { type: 'poly', points: p, box: polyBox(p) };
      case 'star': p = starPoints(5, 50, 21); return { type: 'poly', points: p, box: polyBox(p) };
      case 'burst': p = starPoints(12, 50, 33); return { type: 'poly', points: p, box: polyBox(p) };
      case 'bolt': p = [{ x: 56, y: 0 }, { x: 16, y: 58 }, { x: 44, y: 58 }, { x: 28, y: 100 }, { x: 84, y: 40 }, { x: 52, y: 40 }]; return { type: 'poly', points: p, box: polyBox(p) };
      case 'scallop': return { type: 'path', d: scallopPath(46, 12), box: [-8, -8, 108, 108] };
      case 'heart': return { type: 'path', d: 'M50 30 C 35 0 0 5 0 35 C 0 60 30 75 50 95 C 70 75 100 60 100 35 C 100 5 65 0 50 30 Z', box: [0, 0, 100, 95] };
      case 'teardrop': return { type: 'path', d: 'M30 0 C 45 38 58 55 58 75 A 28 28 0 1 1 2 75 C 2 55 15 38 30 0 Z', box: [0, 0, 60, 103] };
      case 'curved-arrow': return { type: 'path', d: 'M10 80 C 10 30 50 14 86 30 L 80 10 L 118 36 L 78 50 L 88 33 C 56 20 26 34 26 80 Z', box: [10, 10, 108, 70] };
      default: return { type: 'rect', x: 0, y: 0, w: 90, h: 60, rx: 4, box: [0, 0, 90, 60] };
    }
  }
  function elementSVG(kind, color) {
    var g = elementGeometry(kind), inner;
    if (g.type === 'circle') inner = '<circle cx="' + g.cx + '" cy="' + g.cy + '" r="' + g.r + '"';
    else if (g.type === 'ellipse') inner = '<ellipse cx="' + g.cx + '" cy="' + g.cy + '" rx="' + g.rx + '" ry="' + g.ry + '"';
    else if (g.type === 'rect') inner = '<rect x="' + g.x + '" y="' + g.y + '" width="' + g.w + '" height="' + g.h + '" rx="' + g.rx + '"';
    else if (g.type === 'path') inner = '<path d="' + g.d + '"';
    else inner = '<polygon points="' + g.points.map(function (p) { return p.x + ',' + p.y; }).join(' ') + '"';
    return '<svg viewBox="' + g.box.join(' ') + '" preserveAspectRatio="xMidYMid meet" width="100%" height="100%" aria-hidden="true">' + inner + ' fill="' + color + '" /></svg>';
  }
  // Elements menu contents (grouped). Sticker values carry a "sticker:" prefix.
  var ELEMENTS = [
    { group: 'Basic', items: [['rect', 'Rectangle'], ['circle', 'Circle'], ['oval', 'Oval'], ['trapezoid', 'Trapezoid'], ['banner', 'Banner']] },
    { group: 'Polygons', items: [['pentagon', 'Pentagon'], ['hexagon', 'Hexagon'], ['octagon', 'Octagon']] },
    { group: 'Triangles', items: [['triangle-eq', 'Triangle — equilateral'], ['triangle-iso', 'Triangle — isosceles'], ['triangle-right', 'Triangle — right']] },
    { group: 'Arrows', items: [['arrow', 'Arrow'], ['arrow-double', 'Double-ended arrow'], ['curved-arrow', 'Curved arrow'], ['chevron', 'Chevron']] },
    { group: 'Stars & more', items: [['star', 'Star'], ['burst', 'Starburst'], ['bolt', 'Bolt'], ['scallop', 'Scalloped circle'], ['heart', 'Heart'], ['teardrop', 'Teardrop']] }
  ];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function money(n) {
    return '$' + Number(n).toFixed(2);
  }

  function DesignStudio(root, config) {
    this.root = root;
    this.config = config || {};
    this.tierProducts = null;
    this.golfData = null;
    this.el = {
      clubType: root.querySelectorAll('input[name="ds_club_type"]'),
      sizeModeRow: root.querySelector('#ds-sizemode-row'),
      sizeMode: root.querySelectorAll('input[name="ds_size_mode"]'),
      panels: root.querySelectorAll('.ds-panel'),
      ageGroup: root.querySelectorAll('input[name="ds_age_group"]'),
      universalQty: root.querySelector('#ds_universal_qty'),
      qtySteppers: root.querySelectorAll('[data-qty-step]'),
      brand: root.querySelector('#ds_brand'),
      collection: root.querySelector('#ds_collection'),
      model: root.querySelector('#ds_model'),
      year: root.querySelector('#ds_year'),
      shaft: root.querySelector('#ds_shaft_length'),
      grip: root.querySelector('#ds_grip_length'),
      clubs: root.querySelectorAll('.ds-club-checkbox'),
      clubsAll: root.querySelector('#ds_clubs_all'),
      price: root.querySelector('#ds-price'),
      priceBreakdown: root.querySelector('#ds-price-breakdown'),
      message: root.querySelector('#ds-message'),
      addToCart: root.querySelector('#ds-add-to-cart'),
      rights: root.querySelector('#ds-rights'),
      finishBtns: root.querySelectorAll('[data-finish]'),
      canvas: root.querySelector('#ds-canvas'),
      caption: root.querySelector('#ds-canvas-caption'),
      // editor toolbar
      toolbar: root.querySelector('#ds-toolbar'),
      fileInput: root.querySelector('#ds-file'),
      btnUpload: root.querySelector('#ds-tool-upload'),
      btnText: root.querySelector('#ds-tool-text'),
      btnRect: root.querySelector('#ds-tool-rect'),
      btnCircle: root.querySelector('#ds-tool-circle'),
      stickers: root.querySelectorAll('.ds-sticker'),
      color: root.querySelector('#ds-color'),
      fontFamily: root.querySelector('#ds-font'),
      fontSize: root.querySelector('#ds-fontsize'),
      btnForward: root.querySelector('#ds-tool-forward'),
      btnBackward: root.querySelector('#ds-tool-backward'),
      btnDup: root.querySelector('#ds-tool-duplicate'),
      btnFlip: root.querySelector('#ds-tool-flip'),
      btnDelete: root.querySelector('#ds-tool-delete'),
      btnReplaceAll: root.querySelector('#ds-replace-all'),
      btnUndo: root.querySelector('#ds-tool-undo'),
      btnRedo: root.querySelector('#ds-tool-redo'),
      btnZoomIn: root.querySelector('#ds-zoom-in'),
      btnZoomOut: root.querySelector('#ds-zoom-out'),
      btnZoomReset: root.querySelector('#ds-zoom-reset'),
      zoomLabel: root.querySelector('#ds-zoom-label'),
      // v2 additions
      elements: root.querySelector('#ds-elements'),
      elementsBtn: root.querySelector('#ds-elements-btn'),
      elementsMenu: root.querySelector('#ds-elements-menu'),
      flags: root.querySelector('#ds-flags'),
      flagsBtn: root.querySelector('#ds-flags-btn'),
      flagsMenu: root.querySelector('#ds-flags-menu'),
      strokeColor: root.querySelector('#ds-stroke-color'),
      strokeWidth: root.querySelector('#ds-stroke-width'),
      dpi: root.querySelector('#ds-dpi'),
      btnCrop: root.querySelector('#ds-tool-crop'),
      cropBar: root.querySelector('#ds-crop-bar'),
      cropApply: root.querySelector('#ds-crop-apply'),
      cropCancel: root.querySelector('#ds-crop-cancel'),
      bgColor: root.querySelector('#ds-bg-color'),
      bgClear: root.querySelector('#ds-bg-clear'),
      stage: root.querySelector('#ds-canvas-stage'),
      inspectorEmpty: root.querySelector('#ds-inspector-empty'),
      inspectorBody: root.querySelector('#ds-inspector-body'),
      sheetClose: root.querySelector('#ds-sheet-close'),
      inspSections: root.querySelectorAll('.ds-insp-section'),
      // Phase 3
      templateSelect: root.querySelector('#ds-template-select'),
      saveLink: root.querySelector('#ds-save-link'),
      clubPreview: root.querySelector('#ds-club-preview'),
      clubPreviewMsg: root.querySelector('#ds-club-preview-msg'),
      restoreBanner: root.querySelector('#ds-restore'),
      restoreYes: root.querySelector('#ds-restore-yes'),
      restoreNo: root.querySelector('#ds-restore-no'),
      // first-visit guided tour (spotlight)
      wizard: root.querySelector('#ds-wizard'),
      wizMasks: root.querySelectorAll('.ds-wiz-mask'),
      wizMaskTop: root.querySelector('.ds-wiz-mask--top'),
      wizMaskBottom: root.querySelector('.ds-wiz-mask--bottom'),
      wizMaskLeft: root.querySelector('.ds-wiz-mask--left'),
      wizMaskRight: root.querySelector('.ds-wiz-mask--right'),
      wizHole: root.querySelector('#ds-wiz-hole'),
      wizRing: root.querySelector('#ds-wiz-ring'),
      wizTip: root.querySelector('#ds-wiz-tip'),
      wizTitle: root.querySelector('#ds-wiz-title'),
      wizBody: root.querySelector('#ds-wiz-body'),
      wizCount: root.querySelector('#ds-wiz-count'),
      wizardBack: root.querySelector('#ds-wizard-back'),
      wizardNext: root.querySelector('#ds-wizard-next'),
      wizardSkip: root.querySelector('#ds-wizard-skip'),
      wizardDots: root.querySelector('#ds-wizard-dots')
    };
    this._lsKey = 'ds-design:' + (this.config && this.config.productTitle ? this.config.productTitle : 'design');
    this._fileTemplates = {};
    this.ironsData = null;
    this.fabricCanvas = null;
    this._baseColor = null;
    this._baseGradient = null; // wrap-background gradient descriptor {kind,from,to,angle} or null
    this._vinylFinish = 'Gloss'; // Gloss | Matte — default Gloss (matches the is-active button in the markup)
    this._history = []; this._histIdx = -1; this._suspend = false; this._zoom = 1;
    this.init();
  }

  DesignStudio.prototype.init = function () {
    var self = this;
    this.bindEvents();
    this.bindEditor();
    this.bindWizard();
    this.buildElementsMenu();
    this.updatePanels();
    this.initCanvas();
    this.maybeShowWizard();

    Promise.all([
      fetch(this.config.tierProductsUrl).then(function (r) { return r.json(); }).catch(function () { return null; }),
      fetch(this.config.golfClubDataUrl).then(function (r) { return r.json(); }).catch(function () { return null; }),
      this.config.ironsDimensionsUrl
        ? fetch(this.config.ironsDimensionsUrl).then(function (r) { return r.json(); }).catch(function () { return null; })
        : Promise.resolve(null),
      this.config.templatesUrl
        ? fetch(this.config.templatesUrl).then(function (r) { return r.json(); }).catch(function () { return null; })
        : Promise.resolve(null),
      this.config.flagsUrl
        ? fetch(this.config.flagsUrl).then(function (r) { return r.json(); }).catch(function () { return null; })
        : Promise.resolve(null)
    ]).then(function (res) {
      self.tierProducts = res[0] && res[0].tierProducts ? res[0].tierProducts : null;
      self.golfData = res[1] && res[1].brands ? res[1].brands : null;
      self.ironsData = res[2] || { brands: {} };
      self.loadTemplateOptions(res[3] && res[3].templates ? res[3].templates : []);
      self.buildFlagsMenu(res[4] && res[4].flags ? res[4].flags : []);
      self.populateBrands();
      self.refresh();
      self.maybeRestore();
    });
    if (this.el.saveLink && !this.uploadConfigured()) this.el.saveLink.hidden = true;
    if (this.isAdmin()) this.injectAdminTools();
  };

  /* ---- first-visit guided tour (spotlight) ---- */
  // Each step highlights one control and explains it. sel=null → centered (no target).
  DesignStudio.prototype.wizardStepDefs = function () {
    return [
      { sel: null, title: 'Welcome to the wrap designer', body: "Here's a quick guided tour of every part of the designer. Use Back / Next to step through — or Skip to jump straight in.", place: 'center' },
      { sel: '.ds-setup', title: 'Start with size & fit', body: 'Choose Universal (one standard size) or Custom. Pick Custom and this section reveals brand, model, year and an iron picker — you design one wrap and we scale it to fit every club you select.', place: 'bottom' },
      { sel: '#ds-template-select', title: 'Start from a template', body: "Don't want to start from scratch? Pick a ready-made layout and make it your own.", place: 'right' },
      { sel: '#ds-tool-upload', title: 'Add an image', body: 'Upload your own artwork or photo (PNG, JPG, SVG or WebP).', place: 'right' },
      { sel: '#ds-tool-text', title: 'Add text', body: 'Drop in editable text — double-click it on the canvas to type, then style it on the right.', place: 'right' },
      { sel: '#ds-elements-btn', title: 'Add elements', body: 'Insert shapes — rectangles, circles, polygons, triangles, arrows, banners, hearts and more — all from this Elements menu (each with a preview).', place: 'right' },
      { sel: '#ds-flags-btn', title: 'Add a flag', body: 'Drop in any country flag — every flag, listed A→Z with a preview, in this Flags menu.', place: 'right' },
      { sel: '#ds-tool-undo', title: 'Undo & redo', body: 'Made a mistake? Step backward and forward through your changes here (or press Ctrl+Z / Ctrl+Y).', place: 'right' },
      { sel: '#ds-zoom-in', title: 'Zoom & pan', body: 'Zoom in for detail with these buttons — or just scroll your mouse wheel anywhere in the design panel. Hold Ctrl and drag the canvas to pan around.', place: 'right' },
      { sel: '#ds-canvas-stage', title: 'Your wrap canvas', body: 'Drag to move, pull the corners to resize, and use the top handle to rotate (snaps to 45° — hold Ctrl to rotate freely). Elements snap to the wrap centerline; hold Ctrl to place freely. Keep key art inside the dashed safe area — anything outside it won\'t print.', place: 'left' },
      { sel: '#ds-bg-color', title: 'Wrap base color', body: 'Fill the whole wrap with a background color behind your art — or leave it clear with “None”.', place: 'left' },
      { sel: '.ds-inspector', title: 'Edit the selected element', body: 'Select any element and this panel lets you change its color, outline, font & size, image quality (DPI), and stacking order (forward, back, duplicate, delete). “Replace all with this” swaps every other element for a copy of the selected one — great for repeating a shape or flag.', place: 'left' },
      { sel: '.ds-summary', title: 'Live price', body: 'Your price updates automatically with a clear breakdown as you change size and clubs.', place: 'top' },
      { sel: '#ds-save-link', title: 'Save & resume', body: 'Save a link to your design to finish later or continue on another device.', place: 'top' },
      { sel: '#ds-add-to-cart', title: 'Add to cart', body: "When you're happy, add to cart — your design is submitted automatically, and the cart shows a “Custom Graphic” confirmation so you know it went through.", place: 'top' },
      { sel: null, title: "You're ready!", body: "That's the whole designer. Click Start designing to begin — everything you just saw is waiting for you.", place: 'center' }
    ];
  };

  DesignStudio.prototype.bindWizard = function () {
    var self = this, e = this.el;
    if (e.wizardNext) e.wizardNext.addEventListener('click', function () { self.wizardNav(1); });
    if (e.wizardBack) e.wizardBack.addEventListener('click', function () { self.wizardNav(-1); });
    if (e.wizardSkip) e.wizardSkip.addEventListener('click', function () { self.finishWizard(); });
    document.addEventListener('keydown', function (ev) {
      if (!e.wizard || e.wizard.hidden) return;
      if (ev.key === 'Escape') self.finishWizard();
      else if (ev.key === 'ArrowRight') self.wizardNav(1);
      else if (ev.key === 'ArrowLeft') self.wizardNav(-1);
    });
    // Keep the spotlight aligned on resize/scroll; block manual wheel so it stays put.
    var relayout = function () { if (e.wizard && !e.wizard.hidden) self.relayoutWizard(); };
    window.addEventListener('resize', relayout);
    window.addEventListener('scroll', relayout, true);
    if (e.wizMasks) Array.prototype.forEach.call(e.wizMasks, function (m) {
      m.addEventListener('wheel', function (ev) { ev.preventDefault(); }, { passive: false });
    });
  };
  DesignStudio.prototype.maybeShowWizard = function () {
    if (!this.el.wizard) return;
    try {
      if (!window.localStorage) return;          // can't remember "seen" → don't nag every visit
      if (localStorage.getItem(WIZARD_KEY)) return; // already seen
      if (this.designParam()) return;            // arriving via a shared resume link
      if (localStorage.getItem(this._lsKey)) return; // has an autosaved design to restore
    } catch (e) { return; }
    this.showWizard();
  };
  DesignStudio.prototype.showWizard = function () {
    var self = this;
    // Move the overlay to <body> so position:fixed is viewport-relative even if an ancestor of the
    // studio has a transform/will-change (Dawn's scroll-reveal animation) — otherwise masks/tooltip
    // would be mispositioned and the dim/blur wouldn't cover the page.
    if (this.el.wizard.parentNode !== document.body) document.body.appendChild(this.el.wizard);
    // Keep only steps whose target is present + visible (e.g. drop "Save link" when uploads are off).
    this._wizSteps = this.wizardStepDefs().filter(function (s) {
      if (!s.sel) return true;
      var t = self.root.querySelector(s.sel);
      return !!(t && t.offsetWidth > 0 && t.offsetHeight > 0);
    });
    this._wizStep = 0;
    this.el.wizard.hidden = false;
    this.renderWizard();
  };
  DesignStudio.prototype.renderWizard = function () {
    var steps = this._wizSteps, n = steps.length, i = this._wizStep, s = steps[i];
    if (!s) { this.finishWizard(); return; }
    this.el.wizTitle.textContent = s.title;
    this.el.wizBody.textContent = s.body;
    if (this.el.wizardDots) {
      this.el.wizardDots.innerHTML = '';
      for (var d = 0; d < n; d++) {
        var dot = document.createElement('span');
        dot.className = 'ds-wizard-dot' + (d === i ? ' is-active' : '');
        this.el.wizardDots.appendChild(dot);
      }
    }
    if (this.el.wizCount) this.el.wizCount.textContent = (i + 1) + ' / ' + n;
    if (this.el.wizardBack) this.el.wizardBack.disabled = (i === 0);
    if (this.el.wizardNext) this.el.wizardNext.textContent = (i === n - 1) ? 'Start designing' : 'Next →';
    this.positionWizard(); // scrolls target into view, then lays out
  };
  DesignStudio.prototype.wizardNav = function (dir) {
    var next = this._wizStep + dir;
    if (next < 0) return;
    if (next >= this._wizSteps.length) { this.finishWizard(); return; }
    this._wizStep = next;
    this.renderWizard();
  };
  DesignStudio.prototype.finishWizard = function () {
    try { if (window.localStorage) localStorage.setItem(WIZARD_KEY, '1'); } catch (e) {}
    if (this.el.wizard) this.el.wizard.hidden = true;
  };

  // Scroll the current target into view, then position the spotlight + tooltip.
  DesignStudio.prototype.positionWizard = function () {
    var self = this;
    var s = this._wizSteps[this._wizStep];
    var target = s && s.sel ? this.root.querySelector(s.sel) : null;
    if (target && target.scrollIntoView) target.scrollIntoView({ block: 'center', inline: 'nearest' });
    window.requestAnimationFrame(function () { self.relayoutWizard(); });
  };
  DesignStudio.prototype.relayoutWizard = function () {
    var s = this._wizSteps && this._wizSteps[this._wizStep];
    if (!s) return;
    var target = s.sel ? this.root.querySelector(s.sel) : null;
    if (!target || target.offsetWidth === 0) { this.layoutCenteredWizard(); return; }
    this.layoutSpotlight(target, s.place);
  };
  DesignStudio.prototype._setBox = function (elm, x, y, w, h) {
    if (!elm) return;
    elm.style.left = x + 'px'; elm.style.top = y + 'px';
    elm.style.width = Math.max(0, w) + 'px'; elm.style.height = Math.max(0, h) + 'px';
  };
  DesignStudio.prototype.layoutSpotlight = function (target, place) {
    var e = this.el, vw = window.innerWidth, vh = window.innerHeight, pad = 6;
    var r = target.getBoundingClientRect();
    var hx = Math.max(0, r.left - pad), hy = Math.max(0, r.top - pad);
    var hr = Math.min(vw, r.right + pad), hb = Math.min(vh, r.bottom + pad);
    var hw = hr - hx, hh = hb - hy;
    this._setBox(e.wizMaskTop, 0, 0, vw, hy);
    this._setBox(e.wizMaskBottom, 0, hb, vw, vh - hb);
    this._setBox(e.wizMaskLeft, 0, hy, hx, hh);
    this._setBox(e.wizMaskRight, hr, hy, vw - hr, hh);
    if (e.wizHole) { e.wizHole.hidden = false; this._setBox(e.wizHole, hx, hy, hw, hh); }
    if (e.wizRing) { e.wizRing.hidden = false; this._setBox(e.wizRing, hx, hy, hw, hh); }
    this.placeTip(r, place);
  };
  DesignStudio.prototype.layoutCenteredWizard = function () {
    var e = this.el, vw = window.innerWidth, vh = window.innerHeight;
    this._setBox(e.wizMaskTop, 0, 0, vw, vh); // full-screen blur
    this._setBox(e.wizMaskBottom, 0, 0, 0, 0);
    this._setBox(e.wizMaskLeft, 0, 0, 0, 0);
    this._setBox(e.wizMaskRight, 0, 0, 0, 0);
    if (e.wizHole) e.wizHole.hidden = true;
    if (e.wizRing) e.wizRing.hidden = true;
    var tr = e.wizTip.getBoundingClientRect();
    e.wizTip.style.left = Math.max(8, (vw - tr.width) / 2) + 'px';
    e.wizTip.style.top = Math.max(8, (vh - tr.height) / 2) + 'px';
  };
  DesignStudio.prototype.placeTip = function (r, place) {
    var tip = this.el.wizTip, vw = window.innerWidth, vh = window.innerHeight, gap = 14, m = 8;
    var tr = tip.getBoundingClientRect(), tw = tr.width, th = tr.height;
    var cx = (r.left + r.right) / 2, cy = (r.top + r.bottom) / 2;
    var fits = function (x, y) { return x >= m && y >= m && x + tw <= vw - m && y + th <= vh - m; };
    var at = function (p) {
      if (p === 'right') return { x: r.right + gap, y: cy - th / 2 };
      if (p === 'left') return { x: r.left - gap - tw, y: cy - th / 2 };
      if (p === 'bottom') return { x: cx - tw / 2, y: r.bottom + gap };
      if (p === 'top') return { x: cx - tw / 2, y: r.top - gap - th };
      return { x: (vw - tw) / 2, y: (vh - th) / 2 };
    };
    var order = [];
    if (place && place !== 'auto') order.push(place);
    ['right', 'left', 'bottom', 'top'].forEach(function (p) { if (order.indexOf(p) < 0) order.push(p); });
    var pos = null;
    for (var k = 0; k < order.length; k++) { var c = at(order[k]); if (fits(c.x, c.y)) { pos = c; break; } }
    if (!pos) pos = { x: cx - tw / 2, y: r.bottom + gap };
    pos.x = Math.min(Math.max(m, pos.x), vw - m - tw);
    pos.y = Math.min(Math.max(m, pos.y), vh - m - th);
    tip.style.left = pos.x + 'px'; tip.style.top = pos.y + 'px';
  };

  DesignStudio.prototype.bindEvents = function () {
    var self = this;
    Array.prototype.forEach.call(this.el.clubType || [], function (r) {
      r.addEventListener('change', function () { self.onClubTypeChange(); });
    });
    Array.prototype.forEach.call(this.el.sizeMode, function (r) {
      r.addEventListener('change', function () { self.updatePanels(); self.refresh(); });
    });
    Array.prototype.forEach.call(this.el.ageGroup, function (r) {
      r.addEventListener('change', function () { self.refresh(); });
    });
    if (this.el.universalQty) this.el.universalQty.addEventListener('input', function () { self.refresh(); });
    // Custom −/+ stepper buttons (native number spinners style inconsistently). Generic: each button
    // steps the number input inside its own .ds-stepper wrapper — used by "Number of wraps" and the
    // inspector's text "Size". Dispatching 'input' reuses that field's own handler (refresh / applyFontSize).
    Array.prototype.forEach.call(this.el.qtySteppers || [], function (b) {
      b.addEventListener('click', function () {
        var wrap = (b.closest && b.closest('.ds-stepper')) || b.parentNode;
        var input = wrap && wrap.querySelector('input'); if (!input) return;
        var min = parseInt(input.min, 10); if (isNaN(min)) min = 1;
        var max = parseInt(input.max, 10); if (isNaN(max)) max = 99;
        var step = parseInt(b.getAttribute('data-qty-step'), 10) || 0;
        var v = parseInt(input.value, 10); if (isNaN(v)) v = min;
        input.value = String(Math.max(min, Math.min(max, v + step)));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
    if (this.el.brand) this.el.brand.addEventListener('change', function () { self.onBrandChange(); });
    if (this.el.collection) this.el.collection.addEventListener('change', function () { self.onCollectionChange(); });
    if (this.el.model) this.el.model.addEventListener('change', function () { self.onModelChange(); });
    if (this.el.year) this.el.year.addEventListener('change', function () { self.refresh(); });
    Array.prototype.forEach.call(this.el.clubs, function (c) {
      c.addEventListener('change', function () { self.updateAllButton(); self.refresh(); });
    });
    if (this.el.clubsAll) this.el.clubsAll.addEventListener('click', function () { self.toggleAllClubs(); });
    if (this.el.addToCart) this.el.addToCart.addEventListener('click', function () { self.addToCart(); });
    if (this.el.rights) this.el.rights.addEventListener('change', function () { if (self.el.rights.checked) self.setMessage(''); });
    Array.prototype.forEach.call(this.el.finishBtns || [], function (btn) {
      btn.addEventListener('click', function () { self.setVinylFinish(btn.getAttribute('data-finish')); });
    });
  };

  DesignStudio.prototype.bindEditor = function () {
    var self = this, e = this.el;
    if (e.btnUpload && e.fileInput) {
      e.btnUpload.addEventListener('click', function () { e.fileInput.click(); });
      e.fileInput.addEventListener('change', function (ev) {
        if (ev.target.files && ev.target.files[0]) self.addImageFromFile(ev.target.files[0]);
        ev.target.value = '';
      });
    }
    if (e.btnText) e.btnText.addEventListener('click', function () { self.addText(); });
    if (e.btnRect) e.btnRect.addEventListener('click', function () { self.addShape('rect'); });
    if (e.btnCircle) e.btnCircle.addEventListener('click', function () { self.addShape('circle'); });
    if (e.btnStar) e.btnStar.addEventListener('click', function () { self.addShape('star'); });
    if (e.elementsBtn) e.elementsBtn.addEventListener('click', function (ev) { ev.stopPropagation(); self.toggleElementsMenu(); });
    if (e.elementsMenu) e.elementsMenu.addEventListener('click', function (ev) {
      var btn = ev.target.closest ? ev.target.closest('.ds-el-item') : null;
      if (!btn) return;
      var v = btn.getAttribute('data-value');
      if (v.indexOf('sticker:') === 0) self.addSticker(v.slice(8)); else self.addShape(v);
      self.closeElementsMenu();
    });
    if (e.flagsBtn) e.flagsBtn.addEventListener('click', function (ev) { ev.stopPropagation(); self.toggleFlagsMenu(); });
    if (e.flagsMenu) e.flagsMenu.addEventListener('click', function (ev) {
      var btn = ev.target.closest ? ev.target.closest('.ds-el-item') : null;
      if (!btn) return;
      self.addFlag(btn.getAttribute('data-flag'));
      self.closeFlagsMenu();
    });
    document.addEventListener('click', function (ev) {
      if (e.elements && !e.elements.contains(ev.target)) self.closeElementsMenu();
      if (e.flags && !e.flags.contains(ev.target)) self.closeFlagsMenu();
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') { self.closeElementsMenu(); self.closeFlagsMenu(); } });
    self.bindFillControls(); // solid + gradient controls for both the wrap background and element fill
    if (e.templateSelect) e.templateSelect.addEventListener('change', function () {
      var v = e.templateSelect.value;
      if (v) self.applyTemplate(v);   // apply the chosen template (the dropdown keeps showing it)
      else self.clearDesign();        // "✦ Template ▾" placeholder → clear back to a blank wrap
    });
    if (e.saveLink) e.saveLink.addEventListener('click', function () { self.saveShareLink(); });
    // "See it on a club": shown only when the 3D pop-up is on the page.
    if (e.clubPreview && window.ClubPreviewModal && window.ClubPreviewModal.open) {
      e.clubPreview.hidden = false;
      e.clubPreview.addEventListener('click', function () { self.openClubPreview(); });
    }
    if (e.restoreYes) e.restoreYes.addEventListener('click', function () {
      if (self._pendingRestore) self.restoreState(self._pendingRestore);
      if (e.restoreBanner) e.restoreBanner.hidden = true;
    });
    if (e.restoreNo) e.restoreNo.addEventListener('click', function () {
      self._pendingRestore = null;
      self.clearLocal();
      if (e.restoreBanner) e.restoreBanner.hidden = true;
    });
    Array.prototype.forEach.call(e.stickers, function (s) {
      s.addEventListener('click', function () { self.addSticker(s.getAttribute('data-sticker') || s.textContent.trim()); });
    });
    if (e.fontSize) e.fontSize.addEventListener('input', function () { self.applyFontSize(e.fontSize.value); });
    if (e.fontFamily) e.fontFamily.addEventListener('change', function () { self.applyFontFamily(e.fontFamily.value); });
    if (e.strokeColor) e.strokeColor.addEventListener('input', function () { self.applyStroke(e.strokeColor.value, null); });
    if (e.strokeWidth) e.strokeWidth.addEventListener('input', function () { self.applyStroke(null, e.strokeWidth.value); });
    if (e.btnForward) e.btnForward.addEventListener('click', function () { self.layer(1); });
    if (e.btnBackward) e.btnBackward.addEventListener('click', function () { self.layer(-1); });
    if (e.btnDup) e.btnDup.addEventListener('click', function () { self.duplicateActive(); });
    if (e.btnFlip) e.btnFlip.addEventListener('click', function () { self.flipActive(); });
    if (e.btnDelete) e.btnDelete.addEventListener('click', function () { self.deleteActive(); });
    if (e.btnReplaceAll) e.btnReplaceAll.addEventListener('click', function () { self.replaceAll(); });
    if (e.btnCrop) e.btnCrop.addEventListener('click', function () { self.enterImageCrop(); });
    if (e.cropApply) e.cropApply.addEventListener('click', function () { self.applyCrop(); });
    if (e.cropCancel) e.cropCancel.addEventListener('click', function () { self.cancelCrop(); });
    if (e.btnUndo) e.btnUndo.addEventListener('click', function () { self.undo(); });
    if (e.btnRedo) e.btnRedo.addEventListener('click', function () { self.redo(); });
    // Mobile bottom sheet: "Done" deselects, which hides the properties body (the sheet).
    if (e.sheetClose) e.sheetClose.addEventListener('click', function () {
      var fc = self.fabricCanvas;
      if (fc) { fc.discardActiveObject(); fc.requestRenderAll(); }
      self.syncToolbar();
    });
    // Hold Ctrl and left-drag empty canvas to pan (moves the scene via the viewport transform).
    // Releasing Ctrl mid-drag ends the pan. Ctrl-dragging an object lets Fabric move it instead.
    if (e.stage) {
      e.stage.addEventListener('mousedown', function (ev) {
        if (!ev.ctrlKey || ev.button !== 0) return;
        var fc = self.fabricCanvas;
        if (!fc) return;
        if (fc.findTarget && fc.findTarget(ev)) return; // over an object → let Fabric drag it
        ev.preventDefault(); ev.stopPropagation();
        var last = { x: ev.clientX, y: ev.clientY };
        e.stage.classList.add('ds-panning');
        var mv = function (m) {
          if (!m.ctrlKey) { up(); return; } // require Ctrl to stay held while dragging
          fc.relativePan(new window.fabric.Point(m.clientX - last.x, m.clientY - last.y));
          last.x = m.clientX; last.y = m.clientY;
        };
        var up = function () {
          document.removeEventListener('mousemove', mv); document.removeEventListener('mouseup', up);
          e.stage.classList.remove('ds-panning');
        };
        document.addEventListener('mousemove', mv); document.addEventListener('mouseup', up);
      }, true); // capture phase so Fabric doesn't start a selection
      // Scroll wheel = zoom toward the cursor. The step is PROPORTIONAL to the scroll delta so a
      // mouse notch (~100px) makes a normal ~10% step while a trackpad's tiny deltas make tiny
      // steps (instead of a full step per event, which made trackpad zoom race). Tweak SENS to taste.
      var WHEEL_ZOOM_SENS = 0.0011; // higher = faster zoom
      e.stage.addEventListener('wheel', function (ev) {
        ev.preventDefault();
        var dy = ev.deltaY;
        if (ev.deltaMode === 1) dy *= 16;            // lines → approx px
        else if (ev.deltaMode === 2) dy *= 400;      // pages → approx px
        dy = Math.max(-120, Math.min(120, dy));      // ignore extreme single ticks
        self.zoomAtClient(Math.exp(-dy * WHEEL_ZOOM_SENS), ev.clientX, ev.clientY);
      }, { passive: false });
      // Keep the canvas filling the stage if the window resizes.
      window.addEventListener('resize', function () { self.resizeCanvasToStage(); });

      // --- Touch: pinch-to-zoom + two-finger pan ---
      // A single finger stays with Fabric (tap to select, drag to move/scale/rotate). The moment a
      // second finger lands, the gesture becomes zoom/pan: we cancel any in-progress object drag by
      // nulling Fabric's current transform (so it can't restart on a move) and turn off marquee
      // selection until every finger lifts. Zoom reuses zoomAtClient (clamped) around the pinch
      // midpoint; pan follows the midpoint via relativePan.
      (function () {
        var gest = null; // { dist, m:{x,y} } from the previous touch sample
        var dist2 = function (t) {
          var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
          return Math.sqrt(dx * dx + dy * dy);
        };
        var mid2 = function (t) {
          return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 };
        };
        var abortDrag = function () {
          var fc = self.fabricCanvas;
          if (fc) { fc._currentTransform = null; fc.selection = false; }
        };
        var start = function (ev) {
          if (ev.touches.length < 2 || !self.fabricCanvas) return;
          ev.preventDefault();
          abortDrag();
          self._gesturing = true;
          gest = { dist: dist2(ev.touches), m: mid2(ev.touches) };
          e.stage.classList.add('ds-panning');
        };
        var move = function (ev) {
          if (!self._gesturing) return; // single finger, no active gesture → Fabric handles it
          ev.preventDefault();
          var fc = self.fabricCanvas; if (!fc) return;
          abortDrag(); // keep object drags cancelled for the whole gesture
          if (ev.touches.length < 2 || !gest) return;
          var t = ev.touches, d = dist2(t), m = mid2(t);
          if (gest.dist > 0) self.zoomAtClient(d / gest.dist, m.x, m.y);
          fc.relativePan(new window.fabric.Point(m.x - gest.m.x, m.y - gest.m.y));
          gest = { dist: d, m: m };
        };
        var end = function (ev) {
          if (!self._gesturing) return;
          if (ev.touches.length >= 2) { gest = { dist: dist2(ev.touches), m: mid2(ev.touches) }; return; }
          if (ev.touches.length === 1) { gest = null; return; } // ignore lone leftover finger
          self._gesturing = false; gest = null;
          var fc = self.fabricCanvas;
          if (fc) { fc.selection = true; fc.requestRenderAll(); }
          e.stage.classList.remove('ds-panning');
        };
        e.stage.addEventListener('touchstart', start, { passive: false });
        e.stage.addEventListener('touchmove', move, { passive: false });
        e.stage.addEventListener('touchend', end, { passive: false });
        e.stage.addEventListener('touchcancel', end, { passive: false });
      })();
    }
    if (e.btnZoomIn) e.btnZoomIn.addEventListener('click', function () { self.zoomBy(1.2); });
    if (e.btnZoomOut) e.btnZoomOut.addEventListener('click', function () { self.zoomBy(1 / 1.2); });
    if (e.btnZoomReset) e.btnZoomReset.addEventListener('click', function () { self.zoomReset(); });
    // Keyboard: Delete/Backspace removes selection; Ctrl/Cmd+Z / +Y / +Shift+Z for undo/redo.
    document.addEventListener('keydown', function (ev) {
      var inStudio = self.root.contains(document.activeElement) || self.fabricCanvas && self.fabricCanvas.getActiveObject();
      var a = self.active();
      if ((ev.key === 'Delete' || ev.key === 'Backspace') && a && a.dsRole !== 'bg' && !a.isEditing) {
        ev.preventDefault(); self.deleteActive(); return;
      }
      if ((ev.ctrlKey || ev.metaKey) && !(a && a.isEditing) && inStudio) {
        var k = ev.key.toLowerCase();
        var ae = document.activeElement;
        var inField = ae && /^(INPUT|SELECT|TEXTAREA)$/.test(ae.tagName); // let native copy/paste work in fields
        if (k === 'z' && !ev.shiftKey) { ev.preventDefault(); self.undo(); }
        else if ((k === 'z' && ev.shiftKey) || k === 'y') { ev.preventDefault(); self.redo(); }
        else if (k === 'c' && !ev.shiftKey && !inField && a && a.dsRole !== 'bg') { ev.preventDefault(); self.copySelection(); }
        else if (k === 'v' && !ev.shiftKey && !inField && self._clipboard) { ev.preventDefault(); self.pasteClipboard(); }
      }
      // Arrow-key nudge (1px, or 10px with Shift) for the selected artwork.
      if (a && a.dsRole !== 'bg' && !a.isEditing && inStudio && ev.key.indexOf('Arrow') === 0) {
        ev.preventDefault();
        var step = ev.shiftKey ? 10 : 1;
        if (ev.key === 'ArrowLeft') a.left -= step;
        else if (ev.key === 'ArrowRight') a.left += step;
        else if (ev.key === 'ArrowUp') a.top -= step;
        else if (ev.key === 'ArrowDown') a.top += step;
        a.setCoords(); self.fabricCanvas.requestRenderAll();
      }
    });
    this.syncToolbar();
  };

  DesignStudio.prototype.sizeMode = function () {
    var checked = this.root.querySelector('input[name="ds_size_mode"]:checked');
    return checked ? checked.value : 'Universal';
  };

  DesignStudio.prototype.ageGroup = function () {
    var checked = this.root.querySelector('input[name="ds_age_group"]:checked');
    return checked ? checked.value : 'Adult';
  };

  DesignStudio.prototype.clubType = function () {
    var checked = this.root.querySelector('input[name="ds_club_type"]:checked');
    return checked ? checked.value : 'Iron';
  };
  DesignStudio.prototype.clubTypeKey = function () { return this.clubType() === 'Driver' ? 'driver' : 'iron'; };
  // Driver is universal-only: force Universal mode and hide the size-mode + "fit my clubs" UI.
  DesignStudio.prototype.onClubTypeChange = function () {
    if (this.clubTypeKey() === 'driver') {
      var uni = this.root.querySelector('input[name="ds_size_mode"][value="Universal"]');
      if (uni) uni.checked = true;
    }
    this.updatePanels();
    this.rebuildTemplateOptions();
    this.refresh();
  };

  DesignStudio.prototype.selectedClubs = function () {
    var out = [];
    Array.prototype.forEach.call(this.el.clubs, function (c) { if (c.checked) out.push(c.value); });
    return out;
  };

  // "Select all" toggles to "Clear all" once everything is checked.
  DesignStudio.prototype.allClubsChecked = function () {
    var boxes = this.el.clubs;
    return boxes.length > 0 && Array.prototype.every.call(boxes, function (c) { return c.checked; });
  };
  DesignStudio.prototype.toggleAllClubs = function () {
    var target = !this.allClubsChecked();
    Array.prototype.forEach.call(this.el.clubs, function (c) { c.checked = target; });
    this.updateAllButton();
    this.refresh();
  };
  DesignStudio.prototype.updateAllButton = function () {
    if (this.el.clubsAll) this.el.clubsAll.textContent = this.allClubsChecked() ? 'Clear all' : 'Select all';
  };

  DesignStudio.prototype.updatePanels = function () {
    var driver = this.clubTypeKey() === 'driver';
    var mode = driver ? 'Universal' : this.sizeMode();
    // Driver is universal-only — hide the Universal/Custom size-mode toggle entirely.
    if (this.el.sizeModeRow) this.el.sizeModeRow.hidden = driver;
    Array.prototype.forEach.call(this.el.panels, function (p) {
      p.hidden = p.getAttribute('data-panel') !== mode;
    });
  };

  /* ---- cascading dropdowns (Custom mode) ---- */
  function fillSelect(select, entries, placeholder) {
    select.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = ''; opt0.textContent = placeholder;
    select.appendChild(opt0);
    entries.forEach(function (e) {
      var o = document.createElement('option');
      o.value = e.key; o.textContent = e.name; o.dataset.name = e.name;
      select.appendChild(o);
    });
  }

  function entriesFrom(obj) {
    if (!obj) return [];
    return Object.keys(obj).map(function (k) { return { key: k, name: obj[k].name || k, node: obj[k] }; })
      .sort(function (a, b) { return a.name.localeCompare(b.name); });
  }

  // Context-aware placeholder for a dependent dropdown: lists what still needs picking, e.g.
  // "Select a brand first" / "Select a brand and a collection first". Once ready, the normal label.
  DesignStudio.prototype.cascadePlaceholder = function (field) {
    var prereqByField = {
      collection: [['brand', this.el.brand.value]],
      model: [['brand', this.el.brand.value], ['collection', this.el.collection.value]],
      year: [['brand', this.el.brand.value], ['collection', this.el.collection.value], ['model', this.el.model.value]]
    };
    var missing = (prereqByField[field] || []).filter(function (p) { return !p[1]; }).map(function (p) { return p[0]; });
    if (!missing.length) {
      return { collection: 'Select a Collection', model: 'Select a Model', year: 'Select a Year' }[field];
    }
    var parts = missing.map(function (n) { return 'a ' + n; });
    var joined = parts.length === 1 ? parts[0]
      : parts.length === 2 ? (parts[0] + ' and ' + parts[1])
      : (parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1]);
    return 'Select ' + joined + ' first';
  };

  DesignStudio.prototype.populateBrands = function () {
    if (!this.golfData || !this.el.brand) return;
    fillSelect(this.el.brand, entriesFrom(this.golfData), 'Select a Brand');
    // Seed the dependent dropdowns with their "select … first" prompts on load.
    fillSelect(this.el.collection, [], this.cascadePlaceholder('collection')); this.el.collection.disabled = true;
    fillSelect(this.el.model, [], this.cascadePlaceholder('model')); this.el.model.disabled = true;
    fillSelect(this.el.year, [], this.cascadePlaceholder('year')); this.el.year.disabled = true;
  };

  DesignStudio.prototype.onBrandChange = function () {
    var key = this.el.brand.value;
    var brand = key && this.golfData ? this.golfData[key] : null;
    fillSelect(this.el.collection, entriesFrom(brand && brand.collections), this.cascadePlaceholder('collection'));
    this.el.collection.disabled = !brand;
    fillSelect(this.el.model, [], this.cascadePlaceholder('model')); this.el.model.disabled = true;
    fillSelect(this.el.year, [], this.cascadePlaceholder('year')); this.el.year.disabled = true;
    this.refresh();
  };

  DesignStudio.prototype.onCollectionChange = function () {
    var brand = this.golfData[this.el.brand.value];
    var coll = brand && this.el.collection.value ? brand.collections[this.el.collection.value] : null;
    fillSelect(this.el.model, entriesFrom(coll && coll.models), this.cascadePlaceholder('model'));
    this.el.model.disabled = !coll;
    fillSelect(this.el.year, [], this.cascadePlaceholder('year')); this.el.year.disabled = true;
    this.refresh();
  };

  DesignStudio.prototype.onModelChange = function () {
    var brand = this.golfData[this.el.brand.value];
    var coll = brand ? brand.collections[this.el.collection.value] : null;
    var model = coll && this.el.model.value ? coll.models[this.el.model.value] : null;
    var years = (model && model.years ? model.years : []).map(function (y) { return { key: String(y), name: String(y) }; });
    fillSelect(this.el.year, years, this.cascadePlaceholder('year'));
    this.el.year.disabled = !model;
    this.refresh();
  };

  /* ---- pricing / variant resolution ---- */
  DesignStudio.prototype.resolve = function () {
    // returns { key, count, variant } or null
    if (!this.tierProducts) return null;
    var mode = this.sizeMode();
    var key, count;
    if (mode === 'Universal') {
      if (this.clubTypeKey() === 'driver') key = this.ageGroup() === 'Child' ? 'designDriverChild' : 'designDriverAdult';
      else key = this.ageGroup() === 'Child' ? 'designUniversalChild' : 'designUniversalAdult';
      count = parseInt(this.el.universalQty && this.el.universalQty.value, 10) || 0;
    } else {
      key = 'designCustom';
      count = this.selectedClubs().length;
    }
    var product = this.tierProducts[key];
    if (!product || count < 1) return { key: key, count: count, variant: null, product: product };
    var variant = product.variants && product.variants[String(count)];
    return { key: key, count: count, variant: variant || null, product: product };
  };

  DesignStudio.prototype.refresh = function () {
    this.updatePriceDisplay(this.resolve());
    this.updateAllButton();
    this.renderBackground();
    this.setMessage('');
    this.scheduleSave();
  };

  // Total + a plain-language breakdown derived from the configured variant prices,
  // so the math shown always matches what's actually charged.
  DesignStudio.prototype.updatePriceDisplay = function (r) {
    var priceEl = this.el.price, bdEl = this.el.priceBreakdown;
    var setBd = function (t) { if (bdEl) bdEl.textContent = t || ''; };
    if (!r || !r.product) { priceEl.textContent = '—'; setBd(''); return; }
    var unit = r.key === 'designCustom' ? 'club' : 'wrap';
    if (r.count < 1) {
      priceEl.textContent = '—';
      setBd(r.key === 'designCustom' ? 'Select at least one club to see your price.' : 'Choose how many wraps to see your price.');
      return;
    }
    if (!r.variant || r.variant.price == null) { priceEl.textContent = '—'; setBd(''); return; }
    priceEl.textContent = money(r.variant.price);
    setBd(this.priceBreakdown(r, unit));
  };

  DesignStudio.prototype.priceBreakdown = function (r, unit) {
    var v = r.product.variants || {};
    var p1 = v['1'] && v['1'].price, p2 = v['2'] && v['2'].price;
    if (p1 == null || p2 == null) return ''; // can't derive a per-unit step
    var perUnit = p2 - p1, base = p1 - perUnit, n = r.count;
    var unitLabel = n === 1 ? unit : unit + 's';
    var parts = [];
    if (base > 0.005) parts.push(money(base) + ' base');
    parts.push(money(perUnit) + ' × ' + n + ' ' + unitLabel);
    return parts.join(' + ');
  };

  /* ---- canvas: tapered wrap shape + per-club cut lines (Phase 1) ---- */
  var STAGE_MAX_H = 600, STAGE_MAX_W = 320, LEFT_MARGIN = 78, PAD = 12;
  var WORK_MARGIN = 180; // working space (px) around the wrap so elements stay visible well outside it
  var SAFE_MARGIN_IN = 0.125; // visual "keep important art inside" guide, inset from the cut

  DesignStudio.prototype.initCanvas = function () {
    if (!this.el.canvas || typeof window.fabric === 'undefined') return;
    this.fabricCanvas = new window.fabric.Canvas(this.el.canvas, {
      selection: true,
      backgroundColor: '#ffffff',
      preserveObjectStacking: true
    });
    // Finger-friendly selection handles. touchCornerSize only enlarges the tap target on touch
    // events (no effect for mouse), so it's safe to set everywhere. On touch devices we also draw
    // the handles bigger and add a visible outline; desktop keeps Fabric's default look.
    (function (F) {
      if (!F || !F.Object) return;
      F.Object.prototype.touchCornerSize = 44;
      if (F.isTouchSupported) {
        F.Object.prototype.cornerSize = 22;
        F.Object.prototype.transparentCorners = false;
        F.Object.prototype.cornerColor = '#2f6fed';
        F.Object.prototype.cornerStrokeColor = '#ffffff';
        F.Object.prototype.borderScaleFactor = 2;
      }
    })(window.fabric);
    this._geo = null;
    this._history = []; this._histIdx = -1; this._suspend = false;
    var self = this;
    this.resizeCanvasToStage(); // canvas fills the whole stage; pan/zoom use the viewport transform
    this.fabricCanvas.on('selection:created', function () { self.syncToolbar(); });
    this.fabricCanvas.on('selection:updated', function () { self.syncToolbar(); });
    this.fabricCanvas.on('selection:cleared', function () { self.syncToolbar(); });
    // Record history on user edits (background changes are wrapped in _suspend).
    var record = function () { if (!self._suspend) { self.pushHistory(); self.scheduleSave(); } };
    this.fabricCanvas.on('object:added', record);
    this.fabricCanvas.on('object:modified', record);
    this.fabricCanvas.on('object:removed', record);
    // (Wheel-to-zoom is handled panel-wide on the stage element — see bindEditor.)
    // Snapping + alignment guides + rotation snap + DPI updates. (Hold Ctrl to disable snapping.)
    this.fabricCanvas.on('object:moving', function (e) { self.handleSnapping(e.target, e.e); });
    this.fabricCanvas.on('object:rotating', function (e) { self.handleRotation(e.target, e.e); });
    this.fabricCanvas.on('object:scaling', function () { self.updateDpi(); });
    this.fabricCanvas.on('object:modified', function () { self.clearGuides(); self.updateDpi(); });
    this.fabricCanvas.on('mouse:up', function () { self.clearGuides(); });
    this.pushHistory(); // baseline (empty)
  };

  /* ---- snapping + alignment guides ---- */
  DesignStudio.prototype.clearGuides = function () {
    if (!this.fabricCanvas) return;
    var fc = this.fabricCanvas;
    fc.getObjects().filter(function (o) { return o.dsRole === 'guide'; }).forEach(function (o) { fc.remove(o); });
  };
  DesignStudio.prototype._guideLine = function (coords) {
    var l = new window.fabric.Line(coords, { stroke: '#1e9e57', strokeWidth: 1, strokeDashArray: [4, 4], selectable: false, evented: false, excludeFromExport: true });
    l.dsRole = 'guide';
    this.fabricCanvas.add(l); l.bringToFront();
  };
  DesignStudio.prototype.handleSnapping = function (obj, domEvent) {
    if (!obj || obj.dsRole || !this._geo) return;
    var g = this._geo, T = 6;
    var topW = g.trap.topWidthPx, botW = g.trap.botWidthPx, H = g.trap.heightPx;
    var widthAt = function (yRel) {
      var f = Math.max(0, Math.min(1, yRel / H));
      return topW + (botW - topW) * f;
    };
    var prevSuspend = this._suspend;
    this._suspend = true; // guide add/remove must not create history entries mid-drag
    this.clearGuides();
    if (domEvent && domEvent.ctrlKey) { this._suspend = prevSuspend; return; } // Ctrl = move/place freely, no snap

    var c = obj.getCenterPoint();
    var br = obj.getBoundingRect(true, true);            // absolute axis-aligned bounding box
    var ang = ((obj.angle % 90) + 90) % 90;
    var square = (ang < 0.5 || ang > 89.5);              // edges are axis-aligned only at 0/90/180/270

    // Collect snap candidates per axis. Snapping does obj.left/top += (target - cur), which shifts
    // the whole object (and its bbox + center) by the same delta regardless of the object's origin.
    var xc = [];
    var wrapCx = g.offsetX + topW / 2; // wrap centerline (vertical — the isosceles taper is symmetric)
    xc.push({ cur: c.x, target: wrapCx, kind: 'center' });
    this.designObjects().forEach(function (o) { if (o !== obj) xc.push({ cur: c.x, target: o.getCenterPoint().x, kind: 'vx' }); });
    if (square) {
      xc.push({ cur: br.left, target: g.offsetX, kind: 'vx' });                   // left edge -> wrap left
      xc.push({ cur: br.left + br.width, target: g.offsetX + topW, kind: 'vx' });  // right edge -> widest (overflow clips to taper)
    }

    var yc = [];
    yc.push({ cur: c.y, target: g.offsetY + H / 2, kind: 'hy' });                 // wrap mid-height
    this.designObjects().forEach(function (o) { if (o !== obj) yc.push({ cur: c.y, target: o.getCenterPoint().y, kind: 'hy' }); });
    if (square) {
      yc.push({ cur: br.top, target: g.offsetY, kind: 'hy' });                    // top edge -> wrap top
      yc.push({ cur: br.top + br.height, target: g.offsetY + H, kind: 'hy' });    // bottom edge -> wrap bottom
    }

    var pick = function (list) {
      var best = null;
      list.forEach(function (k) { var d = Math.abs(k.cur - k.target); if (d < T && (!best || d < best.d)) best = { d: d, cand: k }; });
      return best;
    };
    var bx = pick(xc), by = pick(yc);

    if (bx) obj.left += (bx.cand.target - bx.cand.cur);
    if (by) obj.top += (by.cand.target - by.cand.cur);
    if (bx || by) obj.setCoords();

    if (bx) {
      if (bx.cand.kind === 'center') {
        this._guideLine([g.offsetX + topW / 2, g.offsetY, g.offsetX + topW / 2, g.offsetY + H]); // vertical centerline
      } else {
        this._guideLine([bx.cand.target, g.offsetY, bx.cand.target, g.offsetY + H]);
      }
    }
    if (by) {
      var gy = by.cand.target;
      var wy = widthAt(gy - g.offsetY); // wrap width at this height; edges are centered
      this._guideLine([g.offsetX + (topW - wy) / 2, gy, g.offsetX + (topW + wy) / 2, gy]);
    }
    this._suspend = prevSuspend;
  };

  // Rotation snaps to 45° increments by default; hold Ctrl to rotate freely.
  DesignStudio.prototype.handleRotation = function (obj, domEvent) {
    if (!obj || obj.dsRole) return;
    if (domEvent && domEvent.ctrlKey) return; // Ctrl = free rotation, no snap
    obj.angle = Math.round((obj.angle || 0) / 45) * 45;
    obj.setCoords();
  };

  /* ---- zoom (CSS transform on the Fabric wrapper; does not touch Fabric coords/clip) ---- */
  var ZMIN = 0.2, ZMAX = 5;
  // Fit the Fabric canvas element to the stage (the whole white area). Pan/zoom use the Fabric
  // viewport transform, so the canvas is one continuous workspace that's editable anywhere.
  DesignStudio.prototype.resizeCanvasToStage = function () {
    var fc = this.fabricCanvas, stage = this.el && this.el.stage;
    if (!fc || !stage) return;
    var w = Math.max(50, Math.round(stage.clientWidth));
    var h = Math.max(50, Math.round(stage.clientHeight));
    if (fc.getWidth() !== w) fc.setWidth(w);
    if (fc.getHeight() !== h) fc.setHeight(h);
  };
  DesignStudio.prototype.updateZoomLabel = function () {
    if (this.el.zoomLabel && this.fabricCanvas) this.el.zoomLabel.textContent = Math.round(this.fabricCanvas.getZoom() * 100) + '%';
  };
  // Centre the wrap in the view. refit=true also picks a zoom that fits the whole wrap (never
  // upscaled past 100%) — used on load, on size changes, and by the Reset button.
  DesignStudio.prototype.viewToWrap = function (refit) {
    var fc = this.fabricCanvas, g = this._geo;
    if (!fc) return;
    this.resizeCanvasToStage();
    var vw = fc.getWidth(), vh = fc.getHeight();
    var z = fc.getZoom() || 1, cx, cy;
    if (g) {
      cx = g.offsetX + g.trap.widthPx / 2; cy = g.offsetY + g.trap.heightPx / 2;
      if (refit) {
        var P = 40; // breathing room around the wrap
        z = Math.min(1, (vw - 2 * P) / g.trap.widthPx, (vh - 2 * P) / g.trap.heightPx);
        if (!isFinite(z) || z <= 0) z = 1;
        z = Math.min(ZMAX, Math.max(ZMIN, z));
      }
    } else { cx = vw / 2 / z; cy = vh / 2 / z; }
    fc.setViewportTransform([z, 0, 0, z, vw / 2 - z * cx, vh / 2 - z * cy]);
    this.updateZoomLabel();
  };
  // Zoom by `factor`, keeping the point under (clientX, clientY) fixed. No point → stage centre.
  DesignStudio.prototype.zoomAtClient = function (factor, clientX, clientY) {
    var fc = this.fabricCanvas; if (!fc) return;
    var z0 = fc.getZoom(), z1 = Math.min(ZMAX, Math.max(ZMIN, z0 * factor));
    if (z1 === z0) return;
    var elc = fc.upperCanvasEl || (fc.getElement && fc.getElement());
    var rect = elc.getBoundingClientRect();
    if (clientX == null) { clientX = rect.left + rect.width / 2; clientY = rect.top + rect.height / 2; }
    fc.zoomToPoint(new window.fabric.Point(clientX - rect.left, clientY - rect.top), z1);
    this.updateZoomLabel();
  };
  DesignStudio.prototype.zoomBy = function (factor) { this.zoomAtClient(factor, null, null); };
  DesignStudio.prototype.zoomReset = function () { this.viewToWrap(true); };

  /* ---- undo / redo (design objects only) ---- */
  DesignStudio.prototype.pushHistory = function () {
    if (!this.fabricCanvas) return;
    var state = JSON.stringify(this.designObjects().map(function (o) { return o.toObject(); }));
    // drop any redo branch, dedupe no-ops
    if (this._histIdx >= 0 && this._history[this._histIdx] === state) return;
    this._history = this._history.slice(0, this._histIdx + 1);
    this._history.push(state);
    if (this._history.length > 40) this._history.shift();
    this._histIdx = this._history.length - 1;
    this.syncToolbar();
  };
  DesignStudio.prototype.restoreHistory = function (state) {
    var fc = this.fabricCanvas, self = this;
    this._suspend = true;
    this.designObjects().forEach(function (o) { fc.remove(o); });
    var objs = JSON.parse(state || '[]');
    if (!objs.length) { this._suspend = false; this.reorderBackground(); fc.discardActiveObject(); fc.requestRenderAll(); this.syncToolbar(); return; }
    window.fabric.util.enlivenObjects(objs, function (enlivened) {
      enlivened.forEach(function (o) { fc.add(o); });
      self.reorderBackground();
      self._suspend = false;
      fc.discardActiveObject(); fc.requestRenderAll(); self.syncToolbar();
    });
  };
  // Base color to the very back; bg guide outlines to the front (always visible over artwork).
  DesignStudio.prototype.reorderBackground = function () {
    var fc = this.fabricCanvas; if (!fc) return;
    fc.getObjects().filter(function (o) { return o.dsRole === 'base'; }).forEach(function (o) { fc.sendToBack(o); });
    fc.getObjects().filter(function (o) { return o.dsRole === 'bg'; }).forEach(function (o) { fc.bringToFront(o); });
  };
  DesignStudio.prototype.undo = function () {
    if (this._cropping || this._histIdx <= 0) return;
    this._histIdx--; this.restoreHistory(this._history[this._histIdx]);
  };
  DesignStudio.prototype.redo = function () {
    if (this._cropping || this._histIdx >= this._history.length - 1) return;
    this._histIdx++; this.restoreHistory(this._history[this._histIdx]);
  };

  // Design objects are everything the user added (no dsRole). Background = boundary + cut lines.
  DesignStudio.prototype.designObjects = function () {
    if (!this.fabricCanvas) return [];
    return this.fabricCanvas.getObjects().filter(function (o) { return o.dsRole !== 'bg' && o.dsRole !== 'guide' && o.dsRole !== 'base' && o.dsRole !== 'cropui'; });
  };

  // Inches of wrap length to render: universal default, or the longest selected club.
  DesignStudio.prototype.canvasStraightInches = function (CW) {
    if (this.clubTypeKey() === 'driver' || this.sizeMode() === 'Universal') {
      return CW.universalStraight(this.clubTypeKey(), this.ageGroup());
    }
    var self = this, max = 0;
    this.selectedClubs().forEach(function (club) {
      var s = CW.clubStraight(self.ironsData, self.selection(), club, self.adjustments());
      if (s > max) max = s;
    });
    return max;
  };

  DesignStudio.prototype.selection = function () {
    return {
      brandKey: this.el.brand.value,
      collectionKey: this.el.collection.value,
      modelKey: this.el.model.value,
      year: this.el.year.value
    };
  };

  DesignStudio.prototype.adjustments = function () {
    return { shaftLength: this.el.shaft.value, gripLength: this.el.grip.value };
  };

  // Redraw ONLY the background (boundary + cut lines) and update the clip, preserving user artwork.
  DesignStudio.prototype.renderBackground = function () {
    var CW = window.ClubWrapDimensions;
    if (!this.fabricCanvas || !CW) return;
    var fc = this.fabricCanvas;
    var self = this;
    this._suspend = true; // don't record background changes in history

    // Remove existing background + base objects only (rebuilt below; artwork preserved).
    fc.getObjects().filter(function (o) { return o.dsRole === 'bg' || o.dsRole === 'base'; }).forEach(function (o) { fc.remove(o); });

    var straight = this.canvasStraightInches(CW);
    if (!straight || straight <= 0) {
      this._geo = null;
      this._lastFitSig = null; // re-selecting a size should refit/centre again
      fc.clipPath = null;
      this.resizeCanvasToStage();
      fc.setViewportTransform([1, 0, 0, 1, 0, 0]);
      this._suspend = false; fc.requestRenderAll(); this.updateZoomLabel();
      if (this.el.caption) this.el.caption.textContent = 'Select your size (and clubs) to see the design area.';
      return;
    }

    var w = CW.widthsFor(this.clubTypeKey(), this.ageGroup());
    var scale = Math.min(CW.PX_PER_INCH, STAGE_MAX_H / straight, STAGE_MAX_W / w.topWidth);
    var trap = CW.trapezoidPoints(straight, scale, w.topWidth, w.botWidth);
    // The wrap sits at a fixed spot in scene space; the canvas fills the stage and we pan/zoom
    // the scene, so no working-margin canvas padding is needed for mobility.
    var offsetX = WORK_MARGIN, offsetY = WORK_MARGIN;
    this._geo = { offsetX: offsetX, offsetY: offsetY, scale: scale, straight: straight, trap: trap };
    fc.clipPath = null; // no clip while editing — artwork stays visible/editable outside the wrap

    // Wrap boundary (outline only, drawn ON TOP so it stays visible over artwork).
    var poly = new window.fabric.Polygon(trap.points, {
      left: offsetX, top: offsetY,
      fill: 'transparent', stroke: '#121212', strokeWidth: 1.5,
      selectable: false, evented: false, objectCaching: false
    });
    poly.dsRole = 'bg';
    fc.add(poly);

    // Wrap base color (fills the whole wrap, behind artwork; exported with the design).
    var baseObj = null;
    var baseFill = this._baseGradient ? this.buildGradient(this._baseGradient) : this._baseColor;
    if (baseFill) {
      baseObj = new window.fabric.Polygon(trap.points, {
        left: offsetX, top: offsetY, fill: baseFill,
        selectable: false, evented: false, objectCaching: false
      });
      baseObj.dsRole = 'base';
      fc.add(baseObj);
    }

    // Safe-area guide: the LEFT/RIGHT edges trace the wrap outline EXACTLY (so the dashed guide
    // overlaps the cut line on both sides — symmetric, no sub-pixel drift), and only the TOP and
    // BOTTOM are inset by SAFE_MARGIN_IN. (Guide only — does not affect the cut dimensions.)
    var safePx = SAFE_MARGIN_IN * scale;
    var sp = trap.points, sH = trap.heightPx;                  // [TL, TR, BR, BL]; left edge TL→BL, right TR→BR
    var syTop = Math.min(safePx, sH / 2), syBot = Math.max(sH - safePx, sH / 2);
    var sxL = function (y) { return sp[0].x + (sp[3].x - sp[0].x) * (y / sH); }; // outline left edge x at height y
    var sxR = function (y) { return sp[1].x + (sp[2].x - sp[1].x) * (y / sH); }; // outline right edge x at height y
    var safe = [
      { x: sxL(syTop), y: syTop }, { x: sxR(syTop), y: syTop },
      { x: sxR(syBot), y: syBot }, { x: sxL(syBot), y: syBot }
    ];
    for (var si = 0; si < safe.length; si++) {
      var a = safe[si], b = safe[(si + 1) % safe.length];
      var sline = new window.fabric.Line([offsetX + a.x, offsetY + a.y, offsetX + b.x, offsetY + b.y], {
        stroke: '#1e6fc8', strokeWidth: 1, strokeDashArray: [4, 4], selectable: false, evented: false, objectCaching: false
      });
      sline.dsRole = 'bg';
      fc.add(sline);
    }

    // (Clipping to the wrap shape happens only at export — see canvasBlob.)
    var topW = trap.topWidthPx, botW = trap.botWidthPx; // grip (wide) and tip (narrow) widths

    // Custom mode: NO per-club cut lines. The customer designs ONE wrap (sized to the longest
    // selected club); fulfillment warps/stretches that single design to fit each club — nothing
    // is trimmed per club, so per-club boundary lines would be both confusing and incorrect.

    // Universal mode: TOP-anchored. Shade the bottom trim/overlap zone (cut to fit shorter clubs);
    // the top is the safe, prime real estate. (clipPath keeps the shading inside the wrap shape.)
    if (this.sizeMode() === 'Universal') {
      var trimFrac = CW.UNIVERSAL.trimFraction || 0.25;
      var trimYrel = (1 - trimFrac) * trap.heightPx;
      var wAtTrim = topW + (botW - topW) * (trimYrel / trap.heightPx); // wrap width at the trim line
      var leftAtTrim = (topW - wAtTrim) / 2;                           // wrap left edge x at the trim line (centered taper)
      // Shaded zone follows the (now symmetric) taper on BOTH sides, so it never overhangs the wrap.
      var zone = new window.fabric.Polygon(
        [
          { x: 0, y: 0 },
          { x: wAtTrim, y: 0 },
          { x: (wAtTrim + botW) / 2, y: trap.heightPx - trimYrel },
          { x: (wAtTrim - botW) / 2, y: trap.heightPx - trimYrel }
        ],
        { left: offsetX + leftAtTrim, top: offsetY + trimYrel, fill: 'rgba(200,30,30,0.12)', selectable: false, evented: false, objectCaching: false }
      );
      zone.dsRole = 'bg';
      var tline = new window.fabric.Line([offsetX + leftAtTrim, offsetY + trimYrel, offsetX + leftAtTrim + wAtTrim, offsetY + trimYrel], {
        stroke: '#c81e1e', strokeWidth: 1, strokeDashArray: [5, 4], selectable: false, evented: false
      });
      tline.dsRole = 'bg';
      fc.add(zone); fc.add(tline);
    }

    // Base color at the very back; guide outlines on top so they stay visible over artwork.
    this.reorderBackground();
    this._suspend = false;
    this.refreshClips(); // clip artwork to the (possibly new) wrap shape
    // Fit + centre the wrap ONLY when its geometry actually changes (load / size / club change) —
    // cosmetic re-renders (e.g. base-color changes) must not reset the user's current zoom/pan.
    var fitSig = straight + '|' + scale;
    if (fitSig !== this._lastFitSig) { this._lastFitSig = fitSig; this.viewToWrap(true); }
    else { this.resizeCanvasToStage(); this.updateZoomLabel(); }
    fc.requestRenderAll();

    if (this.el.caption) {
      var msg;
      if (this.clubTypeKey() === 'driver') {
        msg = 'Universal driver: anchored at the top (grip). Keep key art ABOVE the red line — the shaded bottom may be trimmed to fit your driver.';
      } else if (this.sizeMode() === 'Custom') {
        msg = 'Design one wrap — we stretch it to fit each club you selected. Keep key art inside the dashed safe area.';
      } else {
        msg = 'Universal: anchored at the top (grip). Keep key art ABOVE the red line — the shaded bottom may be trimmed/overlapped to fit shorter clubs.';
      }
      this.el.caption.textContent = msg + ' · Ctrl+drag to pan · scroll to zoom.';
    }
  };

  /* ---- editor operations (Phase 2) ---- */
  DesignStudio.prototype.designCenter = function () {
    var g = this._geo;
    if (!g) return { x: 150, y: 150 };
    return { x: g.offsetX + g.trap.widthPx / 2, y: g.offsetY + g.trap.heightPx / 2 };
  };

  DesignStudio.prototype.addObject = function (obj) {
    var c = this.designCenter();
    obj.set({ left: c.x, top: c.y, originX: 'center', originY: 'center' });
    // Start every new element sized to fit comfortably inside the wrap width.
    if (this._geo) {
      var maxW = this._geo.trap.widthPx * 0.6;
      if (obj.getScaledWidth() > maxW) obj.scaleToWidth(maxW);
    }
    this.fabricCanvas.add(obj);
    this.fabricCanvas.setActiveObject(obj);
    this.reorderBackground(); // keep guides on top, base behind
    this.fabricCanvas.requestRenderAll();
    this.syncToolbar();
  };

  DesignStudio.prototype.addImageFromFile = function (file) {
    if (!file || !this.fabricCanvas) return;
    var self = this;
    var reader = new FileReader();
    reader.onload = function (ev) {
      window.fabric.Image.fromURL(ev.target.result, function (img) {
        var g = self._geo;
        var maxW = g ? g.trap.widthPx * 0.9 : 200;
        if (img.width > maxW) img.scaleToWidth(maxW);
        self.addObject(img);
      }, { crossOrigin: 'anonymous' });
    };
    reader.readAsDataURL(file);
  };

  DesignStudio.prototype.addText = function () {
    var family = this.el.fontFamily ? this.el.fontFamily.value : 'sans-serif';
    var size = 28, txt = 'Your text', w = 160;
    // Measure the text so the box starts on one line (no premature wrap).
    try {
      var ctx = this.fabricCanvas.getContext('2d');
      ctx.save(); ctx.font = size + 'px ' + family; w = Math.max(40, ctx.measureText(txt).width + 8); ctx.restore();
    } catch (e) {}
    // Textbox: side handles change WIDTH and reflow the text (no letter stretch); corners scale
    // the text uniformly. Hide the top/bottom middle handles so it can't be stretched vertically.
    var t = new window.fabric.Textbox(txt, {
      width: w, fontFamily: family, fontSize: size, textAlign: 'center',
      splitByGrapheme: true, // wrap per character so single words stack neatly on the narrow wrap
      fill: this.el.color ? this.el.color.value : '#111111'
    });
    if (t.setControlsVisibility) t.setControlsVisibility({ mt: false, mb: false });
    this.addObject(t);
    t.enterEditing && t.enterEditing();
  };

  DesignStudio.prototype.addShape = function (kind) {
    var fill = this.el.color ? this.el.color.value : '#1e6fc8';
    var F = window.fabric, g = elementGeometry(kind), obj;
    if (g.type === 'circle') obj = new F.Circle({ radius: g.r, fill: fill });
    else if (g.type === 'ellipse') obj = new F.Ellipse({ rx: g.rx, ry: g.ry, fill: fill });
    else if (g.type === 'rect') obj = new F.Rect({ width: g.w, height: g.h, rx: g.rx, ry: g.rx, fill: fill });
    else if (g.type === 'path') obj = new F.Path(g.d, { fill: fill });
    else obj = new F.Polygon(g.points, { fill: fill });
    this.addObject(obj);
  };

  /* ---- custom Elements dropdown (native <option> can't hold thumbnails) ---- */
  DesignStudio.prototype.buildElementsMenu = function () {
    var menu = this.el.elementsMenu;
    if (!menu) return;
    var html = '';
    ELEMENTS.forEach(function (grp) {
      html += '<div class="ds-el-group">' + grp.group + '</div>';
      grp.items.forEach(function (it) {
        var value = it[0], label = it[1];
        var ico = value.indexOf('sticker:') === 0
          ? '<span class="ds-el-glyph">' + value.slice(8) + '</span>'
          : elementSVG(value, '#333333');
        html += '<button type="button" class="ds-el-item" role="menuitem" data-value="' + value + '">' +
          '<span class="ds-el-ico">' + ico + '</span><span class="ds-el-name">' + label + '</span></button>';
      });
    });
    menu.innerHTML = html;
  };
  DesignStudio.prototype.toggleElementsMenu = function () {
    var menu = this.el.elementsMenu; if (!menu) return;
    var open = menu.hidden; this.closeFlagsMenu(); menu.hidden = !open;
    if (this.el.elementsBtn) this.el.elementsBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  DesignStudio.prototype.closeElementsMenu = function () {
    if (this.el.elementsMenu) this.el.elementsMenu.hidden = true;
    if (this.el.elementsBtn) this.el.elementsBtn.setAttribute('aria-expanded', 'false');
  };

  /* ---- Flags dropdown (every country flag, alphabetical; art from flagcdn.com) ---- */
  DesignStudio.prototype.buildFlagsMenu = function (flags) {
    var menu = this.el.flagsMenu; if (!menu) return;
    this._flags = flags || [];
    var html = '';
    this._flags.forEach(function (f) {
      var c = f.code, nm = String(f.name).replace(/"/g, '&quot;');
      html += '<button type="button" class="ds-el-item" role="menuitem" data-flag="' + c + '" data-name="' + nm + '">' +
        '<img class="ds-el-flag" loading="lazy" alt="" src="https://flagcdn.com/24x18/' + c + '.png" srcset="https://flagcdn.com/48x36/' + c + '.png 2x">' +
        '<span class="ds-el-name">' + f.name + '</span></button>';
    });
    menu.innerHTML = html;
  };
  DesignStudio.prototype.toggleFlagsMenu = function () {
    var menu = this.el.flagsMenu; if (!menu) return;
    var open = menu.hidden; this.closeElementsMenu(); menu.hidden = !open;
    if (this.el.flagsBtn) this.el.flagsBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  DesignStudio.prototype.closeFlagsMenu = function () {
    if (this.el.flagsMenu) this.el.flagsMenu.hidden = true;
    if (this.el.flagsBtn) this.el.flagsBtn.setAttribute('aria-expanded', 'false');
  };
  DesignStudio.prototype.addFlag = function (code) {
    if (!this.fabricCanvas || !code) return;
    var self = this;
    this.setMessage('Loading flag…');
    window.fabric.Image.fromURL('https://flagcdn.com/w1280/' + code + '.png', function (img) {
      if (!img || !img.width) { self.setMessage('Sorry, that flag could not be loaded. Please try again.', true); return; }
      self.setMessage('');
      self.addObject(img);
    }, { crossOrigin: 'anonymous' });
  };

  DesignStudio.prototype.addSticker = function (symbol) {
    this.addObject(new window.fabric.IText(symbol, { fontSize: 56, fontFamily: 'sans-serif', editable: false }));
  };

  // Starter templates: the only starters are now the custom ones loaded from design-templates.json
  // and applied via applyFileTemplate (below). The three built-in demo templates (Monogram,
  // Name & number, Stripes) were removed.
  DesignStudio.prototype.applyTemplate = function (name) {
    if (name.indexOf('file:') === 0) { this.applyFileTemplate(name.slice(5)); return; }
    // No built-in templates; any other value (e.g. the empty placeholder) is a no-op.
  };

  // Clear back to a blank wrap (removes all artwork + base fill; keeps size/club type). Undoable.
  DesignStudio.prototype.clearDesign = function () {
    var fc = this.fabricCanvas; if (!fc) return;
    this._suspend = true;
    this.designObjects().forEach(function (o) { fc.remove(o); });
    this._baseColor = null;
    this._baseGradient = null;
    this._suspend = false;
    this.reflectBgFill();     // reset the background fill control to "None"
    this.renderBackground();  // drop the base fill, keep the wrap outline
    fc.discardActiveObject();
    this.pushHistory();
    this.scheduleSave();
    fc.requestRenderAll();
    this.syncToolbar();
  };

  /* ---- custom templates loaded from design-templates.json ---- */
  DesignStudio.prototype.loadTemplateOptions = function (list) {
    if (!list || !list.length) return;
    var self = this;
    list.forEach(function (t) { if (t && t.id) self._fileTemplates[t.id] = t; });
    this.rebuildTemplateOptions();
  };
  // Show only templates matching the current club type — iron templates won't fit a driver wrap and
  // vice-versa. A template's clubType defaults to 'Iron' when unset (every pre-driver template).
  DesignStudio.prototype.rebuildTemplateOptions = function () {
    var sel = this.el.templateSelect; if (!sel) return;
    Array.prototype.slice.call(sel.options).forEach(function (o) { if (o.value.indexOf('file:') === 0) sel.removeChild(o); });
    var current = this.clubType(), self = this;
    Object.keys(this._fileTemplates).forEach(function (id) {
      var t = self._fileTemplates[id];
      if ((t.clubType || 'Iron') !== current) return;
      var o = document.createElement('option');
      o.value = 'file:' + t.id;
      o.textContent = t.label || t.id;
      sel.appendChild(o);
    });
  };

  DesignStudio.prototype.applyFileTemplate = function (id) {
    var t = this._fileTemplates[id];
    if (!t) return;
    if (!this._geo || !this.fabricCanvas) { this.setMessage('Choose your size first, then pick a template.', true); return; }
    // If the template targets a different club type, switch to it first so the wrap geometry matches.
    if (t.clubType && t.clubType !== this.clubType()) {
      var _ct = this.root.querySelector('input[name="ds_club_type"][value="' + t.clubType + '"]');
      if (_ct) { _ct.checked = true; if (this.clubTypeKey() === 'driver') { var _u = this.root.querySelector('input[name="ds_size_mode"][value="Universal"]'); if (_u) _u.checked = true; } this.updatePanels(); this.renderBackground(); }
    }
    var self = this, fc = this.fabricCanvas, C = this._geo;
    var T = t.geo || { offsetX: C.offsetX, offsetY: C.offsetY, scale: C.scale };
    var ratio = T.scale ? C.scale / T.scale : 1;
    // base color (optional part of the template)
    this._baseColor = t.baseColor || null;
    this._baseGradient = t.baseGradient || null;
    if (this.el.bgColor && t.baseColor) this.el.bgColor.value = t.baseColor;
    this.reflectBgFill();
    this._suspend = true;
    this.designObjects().forEach(function (o) { fc.remove(o); });
    var objs = (t.objects || []).slice();
    var finish = function () {
      self.renderBackground(); // rebuild the wrap boundary + BASE COLOR behind the artwork (was reorderBackground, which never painted the base color)
      self._suspend = false;
      self.pushHistory();
      self.scheduleSave();
      fc.discardActiveObject();
      fc.requestRenderAll();
      self.syncToolbar();
      if (window.document && document.fonts) document.fonts.ready.then(function () { fc.requestRenderAll(); });
    };
    if (!objs.length) { finish(); return; }
    window.fabric.util.enlivenObjects(objs, function (enlivened) {
      enlivened.forEach(function (o) {
        // Re-fit from the template's wrap to the current wrap (positions in inches, size by ratio).
        var inchX = (o.left - T.offsetX) / (T.scale || C.scale);
        var inchY = (o.top - T.offsetY) / (T.scale || C.scale);
        o.set({ left: C.offsetX + inchX * C.scale, top: C.offsetY + inchY * C.scale });
        o.scaleX = (o.scaleX || 1) * ratio;
        o.scaleY = (o.scaleY || 1) * ratio;
        o.setCoords();
        fc.add(o);
      });
      finish();
    });
  };

  /* ---- admin-only: capture the current design as a template (open studio with ?admin=1) ---- */
  DesignStudio.prototype.isAdmin = function () {
    return /[?&]admin=1\b/.test(window.location.search || '');
  };
  DesignStudio.prototype.injectAdminTools = function () {
    if (!this.el.templateSelect) return;
    var self = this;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ds-tool';
    btn.textContent = '⭳ Copy as template';
    btn.title = 'Admin: copy this design as a template entry';
    btn.style.marginTop = '0.4rem';
    btn.addEventListener('click', function () { self.captureTemplate(); });
    this.el.templateSelect.parentNode.appendChild(btn);
  };
  DesignStudio.prototype.captureTemplate = function () {
    var g = this._geo;
    if (!g) { this.setMessage('Choose your size first.', true); return; }
    var objs = this.designObjects();
    if (!objs.length && !this._baseColor && !this._baseGradient) { this.setMessage('Add something to the design first.', true); return; }
    var label = window.prompt('Template name?', 'My template');
    if (!label) return;
    var id = label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || ('tpl-' + Date.now());
    var self = this;
    // Serialize; drop the per-object wrap clipPath (re-applied on load, keeps JSON small).
    var serialized = objs.map(function (o) { var d = o.toObject(); delete d.clipPath; return d; });
    // Uploaded images serialize as huge base64 data URLs — upload them to Shopify Files and store
    // a small URL instead (keeps the template tiny + pasteable and design-templates.json lean).
    var uploads = [];
    serialized.forEach(function (d, i) {
      if (d.type === 'image' && typeof d.src === 'string' && d.src.indexOf('data:') === 0) {
        uploads.push({ i: i, blob: self.dataUrlToBlob(d.src) });
      }
    });
    var finalize = function () {
      var tpl = {
        id: id, label: label, clubType: self.clubType(), baseColor: self._baseColor || null, baseGradient: self._baseGradient || null,
        geo: { offsetX: g.offsetX, offsetY: g.offsetY, scale: g.scale }, objects: serialized
      };
      var json = JSON.stringify(tpl, null, 2);
      console.log('[design-studio] template JSON:\n' + json);
      self.copyText(json).then(function (ok) {
        self.setMessage(ok ? 'Template copied — paste it into the templates array in design-templates.json.' : 'Template JSON logged to the console (copy it from there).');
      });
    };
    if (!uploads.length) { finalize(); return; }
    if (!this.uploadConfigured()) { this.setMessage('This template uses an uploaded image, but image upload isn’t configured here — can’t save it.', true); return; }
    this.setMessage('Uploading template image(s)…');
    var uid = this.uuid();
    this.uploadBlobs(uploads.map(function (u, k) {
      return { key: 'img' + k, blob: u.blob, filename: 'tpl-' + uid + '-' + k + '.png', mimeType: 'image/png', resource: 'IMAGE', contentType: 'IMAGE' };
    }), uid).then(function (urls) {
      uploads.forEach(function (u, k) {
        var url = urls['img' + k];
        if (url) { serialized[u.i].src = url; serialized[u.i].crossOrigin = 'anonymous'; }
      });
      finalize();
    }).catch(function () {
      self.setMessage('Sorry, uploading the template image failed. Please try again.', true);
    });
  };

  DesignStudio.prototype.active = function () { return this.fabricCanvas && this.fabricCanvas.getActiveObject(); };

  DesignStudio.prototype.deleteActive = function () {
    if (this._cropping) return;
    var fc = this.fabricCanvas, objs = fc.getActiveObjects();
    objs.forEach(function (o) { if (o.dsRole !== 'bg') fc.remove(o); });
    fc.discardActiveObject(); fc.requestRenderAll(); this.syncToolbar();
  };

  DesignStudio.prototype.duplicateActive = function () {
    var active = this.active(); if (!active || active.dsRole === 'bg') return;
    var self = this, fc = this.fabricCanvas, F = window.fabric;
    // Capture the selected object(s), then drop the selection so each returns to ABSOLUTE canvas
    // coordinates. A multi-select is a fabric.ActiveSelection whose children are stored relative to
    // the group centre — cloning that wrapper and adding it orphaned the copies, which then got
    // clipped away (invisible but still selectable) once deselected. Cloning each object on its own
    // at absolute coords avoids that entirely.
    var sources = fc.getActiveObjects().filter(function (o) { return o.dsRole !== 'bg'; });
    if (!sources.length) return;
    fc.discardActiveObject();
    self._suspend = true; // add all clones first, then record a single history entry
    var clones = [], pending = sources.length;
    sources.forEach(function (src) {
      src.clone(function (c) {
        c.set({ left: src.left + 14, top: src.top + 14, clipPath: null });
        c.setCoords();
        fc.add(c);
        clones.push(c);
        if (--pending > 0) return;
        // All copies added as standalone objects (absolute coords) — record BEFORE re-grouping,
        // so history/autosave capture real positions rather than group-relative ones.
        self.reorderBackground();
        self._suspend = false;
        self.pushHistory();
        self.saveLocal();
        fc.setActiveObject(clones.length === 1 ? clones[0] : new F.ActiveSelection(clones, { canvas: fc }));
        fc.requestRenderAll();
        self.syncToolbar();
      });
    });
  };

  // Ctrl+C: snapshot the current selection to an in-studio clipboard. Dropping the selection first
  // makes grouped children report ABSOLUTE coords, so the paste lands (and clips) correctly.
  DesignStudio.prototype.copySelection = function () {
    var fc = this.fabricCanvas; if (!fc) return;
    var sel = fc.getActiveObjects().filter(function (o) { return o.dsRole !== 'bg'; });
    if (!sel.length) return;
    fc.discardActiveObject();
    this._clipboard = sel.map(function (o) { var d = o.toObject(); delete d.clipPath; return d; });
    this._pasteShift = 0; // a fresh copy: the next paste offsets by one step
    fc.setActiveObject(sel.length === 1 ? sel[0] : new window.fabric.ActiveSelection(sel, { canvas: fc }));
    fc.requestRenderAll();
    this.setMessage(sel.length > 1 ? (sel.length + ' items copied') : 'Copied');
  };

  // Ctrl+V: paste the clipboard as fresh standalone objects, cascading the offset on repeat pastes.
  DesignStudio.prototype.pasteClipboard = function () {
    if (!this._clipboard || !this._clipboard.length || !this._geo || !this.fabricCanvas) return;
    var self = this, fc = this.fabricCanvas, F = window.fabric;
    this._pasteShift = (this._pasteShift || 0) + 14;
    var shift = this._pasteShift;
    F.util.enlivenObjects(this._clipboard.slice(), function (objs) {
      fc.discardActiveObject();
      self._suspend = true;
      var added = [];
      objs.forEach(function (o) {
        o.set({ left: (o.left || 0) + shift, top: (o.top || 0) + shift, clipPath: null });
        o.setCoords();
        fc.add(o);
        added.push(o);
      });
      self.reorderBackground();
      self._suspend = false;
      self.pushHistory();
      self.saveLocal();
      fc.setActiveObject(added.length === 1 ? added[0] : new F.ActiveSelection(added, { canvas: fc }));
      fc.requestRenderAll();
      self.syncToolbar();
    });
  };

  // Replace every OTHER design element with a copy of the selected one, matching each replaced
  // element's position, size and rotation. (The selected element itself stays put.)
  DesignStudio.prototype.replaceAll = function () {
    var sel = this.active();
    if (!sel || sel.dsRole) return;
    var fc = this.fabricCanvas, self = this;
    var others = this.designObjects().filter(function (o) { return o !== sel; });
    if (!others.length) { this.setMessage('Add more elements first — there is nothing else to replace.', true); return; }
    this._suspend = true;
    var pending = others.length;
    others.forEach(function (other) {
      sel.clone(function (clone) {
        var c = other.getCenterPoint(), w = other.getScaledWidth(), h = other.getScaledHeight();
        clone.set({ originX: 'center', originY: 'center', angle: other.angle || 0 });
        if (clone.width) clone.scaleX = w / clone.width;
        if (clone.height) clone.scaleY = h / clone.height;
        clone.setPositionByOrigin(c, 'center', 'center');
        clone.setCoords();
        fc.remove(other);
        fc.add(clone);
        if (--pending === 0) {
          self.reorderBackground();
          self._suspend = false;
          fc.discardActiveObject();
          fc.setActiveObject(sel);
          self.pushHistory();
          self.scheduleSave();
          fc.requestRenderAll();
          self.syncToolbar();
        }
      });
    });
  };

  DesignStudio.prototype.layer = function (dir) {
    var o = this.active(); if (!o || o.dsRole === 'bg') return;
    if (dir > 0) this.fabricCanvas.bringForward(o); else this.fabricCanvas.sendBackwards(o);
    this.reorderBackground(); // base stays behind, guides stay on top
    this.fabricCanvas.requestRenderAll();
  };

  DesignStudio.prototype.flipActive = function () {
    var o = this.active(); if (!o || o.dsRole) return;
    o.set('flipX', !o.flipX); o.setCoords();
    this.fabricCanvas.requestRenderAll();
    this.pushHistory(); this.scheduleSave();
  };

  /* ---- image crop (native Fabric crop; box shrinks to the kept area; works while rotated) ---- */
  DesignStudio.prototype.enterImageCrop = function () {
    var img = this.active();
    if (!img || img.type !== 'image') { this.setMessage('Select an image first to crop it.', true); return; }
    if (this._cropping) return;
    var fc = this.fabricCanvas, F = window.fabric;
    this._suspend = true; this._cropping = true;
    // Overlay matches the image's angle + footprint so you can crop in place, even rotated.
    var overlay = new F.Rect({
      originX: 'center', originY: 'center', angle: img.angle || 0,
      width: img.getScaledWidth(), height: img.getScaledHeight(), scaleX: 1, scaleY: 1,
      fill: 'rgba(47,111,237,0.12)', stroke: '#2f6fed', strokeWidth: 2, strokeDashArray: [5, 4],
      strokeUniform: true, cornerColor: '#2f6fed', transparentCorners: false, cornerSize: 10,
      lockRotation: true, objectCaching: false
    });
    overlay.setPositionByOrigin(img.getCenterPoint(), 'center', 'center');
    overlay.dsRole = 'cropui';
    if (overlay.setControlsVisibility) overlay.setControlsVisibility({ mtr: false });
    fc.add(overlay);
    this._crop = { img: img, overlay: overlay };
    img.selectable = false; img.evented = false;   // don't grab clicks during crop
    fc.setActiveObject(overlay);
    if (this.el.cropBar) this.el.cropBar.hidden = false;
    this.root.classList.add('ds-cropping');
    fc.requestRenderAll();
  };
  DesignStudio.prototype.applyCrop = function () {
    var cr = this._crop; if (!cr) return;
    var F = window.fabric, img = cr.img, o = cr.overlay;
    var sx = img.scaleX || 1, sy = img.scaleY || 1, W = img.width, H = img.height;
    // Overlay center → image-local (centered, source px). Works for any rotation/flip.
    var lc = F.util.transformPoint(o.getCenterPoint(), F.util.invertTransform(img.calcTransformMatrix()));
    var cropW = o.getScaledWidth() / sx, cropH = o.getScaledHeight() / sy;
    // Intersect the crop box with the image (in local centered coords).
    var ix0 = Math.max(lc.x - cropW / 2, -W / 2), ix1 = Math.min(lc.x + cropW / 2, W / 2);
    var iy0 = Math.max(lc.y - cropH / 2, -H / 2), iy1 = Math.min(lc.y + cropH / 2, H / 2);
    if (ix1 - ix0 < 1 || iy1 - iy0 < 1) { this.setMessage('The crop box is off the image — reposition it and try again.', true); return; }
    var newW = ix1 - ix0, newH = iy1 - iy0;
    // Map the kept region to source pixels (mirror the offset if the image is flipped).
    var cropX = (img.cropX || 0) + (img.flipX ? (W / 2 - ix1) : (ix0 + W / 2));
    var cropY = (img.cropY || 0) + (img.flipY ? (H / 2 - iy1) : (iy0 + H / 2));
    // Keep the cropped image where the box was: its new center = box center mapped back to canvas.
    var cc = F.util.transformPoint({ x: (ix0 + ix1) / 2, y: (iy0 + iy1) / 2 }, img.calcTransformMatrix());
    img.set({ cropX: Math.max(0, cropX), cropY: Math.max(0, cropY), width: Math.max(1, newW), height: Math.max(1, newH) });
    img.setPositionByOrigin(new F.Point(cc.x, cc.y), 'center', 'center');
    img.selectable = true; img.evented = true; img.setCoords();
    this._endCrop();
    this._suspend = false; this._cropping = false;
    this.fabricCanvas.setActiveObject(img);
    this.pushHistory(); this.scheduleSave(); this.updateDpi(); this.syncToolbar();
    this.fabricCanvas.requestRenderAll();
  };
  DesignStudio.prototype.cancelCrop = function () {
    var cr = this._crop; if (!cr) return;
    var img = cr.img;
    img.selectable = true; img.evented = true; img.setCoords();
    this._endCrop();
    this._suspend = false; this._cropping = false;
    this.fabricCanvas.setActiveObject(img);
    this.syncToolbar();
    this.fabricCanvas.requestRenderAll();
  };
  DesignStudio.prototype._endCrop = function () {
    var cr = this._crop; if (!cr) return;
    this.fabricCanvas.remove(cr.overlay);
    this._crop = null;
    if (this.el.cropBar) this.el.cropBar.hidden = true;
    this.root.classList.remove('ds-cropping');
  };

  DesignStudio.prototype.applyStroke = function (color, width) {
    var o = this.active(); if (!o || o.dsRole === 'bg') return;
    if (color != null) o.set('stroke', color);
    if (width != null) o.set('strokeWidth', parseInt(width, 10) || 0);
    this.fabricCanvas.requestRenderAll();
  };

  /* ---- gradients (linear/radial, 2 stops) for element fills + the wrap background ----
     Fabric 'percentage' units map coords 0..1 across the target's bounding box regardless of its
     origin, so one descriptor works for any element or the base polygon. Gradients bake into the
     exported PNG, so fulfillment is unaffected. */
  DesignStudio.prototype.buildGradient = function (desc) {
    var F = window.fabric;
    desc = desc || {};
    var stops = [{ offset: 0, color: desc.from || '#ffffff' }, { offset: 1, color: desc.to || '#000000' }];
    if (desc.kind === 'radial') {
      return new F.Gradient({
        type: 'radial', gradientUnits: 'percentage',
        coords: { x1: 0.5, y1: 0.5, r1: 0, x2: 0.5, y2: 0.5, r2: 0.5 }, colorStops: stops
      });
    }
    var rad = (Number(desc.angle) || 0) * Math.PI / 180;
    var dx = Math.cos(rad) * 0.5, dy = Math.sin(rad) * 0.5; // 0°=left→right, 90°=top→bottom
    return new F.Gradient({
      type: 'linear', gradientUnits: 'percentage',
      coords: { x1: 0.5 - dx, y1: 0.5 - dy, x2: 0.5 + dx, y2: 0.5 + dy }, colorStops: stops
    });
  };
  // Recover a descriptor from an object's gradient fill (for reflecting it back into the controls).
  DesignStudio.prototype.fillToDesc = function (fill) {
    if (!fill || typeof fill !== 'object' || !fill.colorStops || !fill.colorStops.length) return null;
    var cs = fill.colorStops, from = cs[0].color, to = cs[cs.length - 1].color;
    if (fill.type === 'radial') return { kind: 'radial', from: from, to: to, angle: 0 };
    var c = fill.coords || {}, ang = Math.round(Math.atan2((c.y2 - c.y1), (c.x2 - c.x1)) * 180 / Math.PI);
    return { kind: 'linear', from: from, to: to, angle: ((ang % 360) + 360) % 360 };
  };

  DesignStudio.prototype.bindFillControls = function () {
    var self = this;
    Array.prototype.forEach.call(this.root.querySelectorAll('.ds-fill'), function (ctrl) {
      var bg = ctrl.getAttribute('data-fill') === 'bg';
      var live = function () { bg ? self.applyBgFill(ctrl, false) : self.applyElementFill(ctrl, false); };
      var commit = function () { bg ? self.applyBgFill(ctrl, true) : self.applyElementFill(ctrl, true); };
      Array.prototype.forEach.call(ctrl.querySelectorAll('[data-fill-mode]'), function (b) {
        b.addEventListener('click', function () { self.setFillMode(ctrl, b.getAttribute('data-fill-mode')); commit(); });
      });
      Array.prototype.forEach.call(ctrl.querySelectorAll('[data-grad-type]'), function (b) {
        b.addEventListener('click', function () { self.setGradType(ctrl, b.getAttribute('data-grad-type')); commit(); });
      });
      var q = function (s) { return ctrl.querySelector(s); };
      var solid = q('.ds-fill-solid input[type="color"]'), from = q('.ds-grad-from'), to = q('.ds-grad-to'), angle = q('.ds-grad-angle');
      if (solid) { solid.addEventListener('input', live); solid.addEventListener('change', commit); }
      if (from) { from.addEventListener('input', live); from.addEventListener('change', commit); }
      if (to) { to.addEventListener('input', live); to.addEventListener('change', commit); }
      if (angle) {
        angle.addEventListener('input', function () { var v = q('.ds-grad-angle-val'); if (v) v.textContent = angle.value + '°'; live(); });
        angle.addEventListener('change', commit);
      }
    });
    this.reflectBgFill();
  };
  DesignStudio.prototype.setFillMode = function (ctrl, mode) {
    Array.prototype.forEach.call(ctrl.querySelectorAll('[data-fill-mode]'), function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-fill-mode') === mode);
    });
    var solid = ctrl.querySelector('.ds-fill-solid'), grad = ctrl.querySelector('.ds-grad');
    if (solid) solid.hidden = mode !== 'solid';
    if (grad) grad.hidden = mode !== 'gradient';
  };
  DesignStudio.prototype.setGradType = function (ctrl, type) {
    Array.prototype.forEach.call(ctrl.querySelectorAll('[data-grad-type]'), function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-grad-type') === type);
    });
    var aw = ctrl.querySelector('.ds-grad-angle-wrap');
    if (aw) aw.hidden = type === 'radial'; // radial has no orientation
  };
  DesignStudio.prototype.readFillControl = function (ctrl) {
    var activeMode = ctrl.querySelector('[data-fill-mode].is-active');
    var typeBtn = ctrl.querySelector('[data-grad-type].is-active');
    var solid = ctrl.querySelector('.ds-fill-solid input[type="color"]');
    var from = ctrl.querySelector('.ds-grad-from'), to = ctrl.querySelector('.ds-grad-to'), angle = ctrl.querySelector('.ds-grad-angle');
    return {
      mode: activeMode ? activeMode.getAttribute('data-fill-mode') : 'solid',
      color: solid ? solid.value : '#000000',
      grad: {
        kind: typeBtn ? typeBtn.getAttribute('data-grad-type') : 'linear',
        from: from ? from.value : '#ffffff',
        to: to ? to.value : '#000000',
        angle: angle ? (parseInt(angle.value, 10) || 0) : 0
      }
    };
  };
  DesignStudio.prototype.applyBgFill = function (ctrl, commit) {
    var v = this.readFillControl(ctrl), fc = this.fabricCanvas;
    if (v.mode === 'none') { this._baseColor = null; this._baseGradient = null; }
    else if (v.mode === 'gradient') { this._baseGradient = v.grad; this._baseColor = null; }
    else { this._baseColor = v.color; this._baseGradient = null; }
    var nowBase = !!(this._baseColor || this._baseGradient);
    var baseObj = fc && fc.getObjects().filter(function (o) { return o.dsRole === 'base'; })[0];
    if (baseObj && nowBase) { // fast in-place update while dragging
      baseObj.set('fill', this._baseGradient ? this.buildGradient(this._baseGradient) : this._baseColor);
      baseObj.dirty = true; fc.requestRenderAll();
    } else {
      this.renderBackground(); // base added or removed — rebuild
    }
    if (commit) this.scheduleSave();
  };
  DesignStudio.prototype.applyElementFill = function (ctrl, commit) {
    var fc = this.fabricCanvas; if (!fc) return;
    var targets = fc.getActiveObjects().filter(function (o) { return !o.dsRole; });
    if (!targets.length) return;
    var v = this.readFillControl(ctrl), self = this;
    targets.forEach(function (o) {
      o.set('fill', v.mode === 'gradient' ? self.buildGradient(v.grad) : v.color); // fresh gradient per object
      o.dirty = true;
    });
    fc.requestRenderAll();
    if (commit) { this.pushHistory(); this.scheduleSave(); }
  };
  DesignStudio.prototype._reflectGrad = function (ctrl, desc) {
    this.setFillMode(ctrl, 'gradient');
    this.setGradType(ctrl, desc.kind || 'linear');
    var from = ctrl.querySelector('.ds-grad-from'); if (from) from.value = desc.from || '#ffffff';
    var to = ctrl.querySelector('.ds-grad-to'); if (to) to.value = desc.to || '#000000';
    var ang = ctrl.querySelector('.ds-grad-angle'), av = ctrl.querySelector('.ds-grad-angle-val');
    if (ang) ang.value = desc.angle || 0;
    if (av) av.textContent = (desc.angle || 0) + '°';
  };
  DesignStudio.prototype.reflectBgFill = function () {
    var ctrl = this.root.querySelector('.ds-fill[data-fill="bg"]'); if (!ctrl) return;
    if (this._baseGradient) this._reflectGrad(ctrl, this._baseGradient);
    else if (this._baseColor) { this.setFillMode(ctrl, 'solid'); var s = ctrl.querySelector('#ds-bg-color'); if (s) s.value = this._baseColor; }
    else this.setFillMode(ctrl, 'none');
  };
  DesignStudio.prototype.reflectElementFill = function () {
    var ctrl = this.root.querySelector('.ds-fill[data-fill="element"]'); if (!ctrl) return;
    var o = this.active();
    var desc = (o && o.fill) ? this.fillToDesc(o.fill) : null;
    if (desc) this._reflectGrad(ctrl, desc);
    else this.setFillMode(ctrl, 'solid'); // solid swatch (#ds-color) is set by syncToolbar
  };

  /* ---- vinyl finish (Gloss | Matte) — a cart + fulfillment line-item property ---- */
  DesignStudio.prototype.vinylFinish = function () { return this._vinylFinish === 'Matte' ? 'Matte' : 'Gloss'; };
  DesignStudio.prototype.setVinylFinish = function (name) {
    this._vinylFinish = (name === 'Matte') ? 'Matte' : 'Gloss';
    var v = this._vinylFinish;
    Array.prototype.forEach.call(this.el.finishBtns || [], function (btn) {
      var on = btn.getAttribute('data-finish') === v;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    this.scheduleSave();
  };

  // Live print-quality (DPI) meter for the selected image.
  DesignStudio.prototype.updateDpi = function () {
    if (!this.el.dpi) return;
    var o = this.active();
    if (!o || o.type !== 'image' || !this._geo) { this.el.dpi.textContent = ''; this.el.dpi.className = 'ds-dpi'; return; }
    var physIn = o.getScaledWidth() / this._geo.scale;            // printed width in inches
    var dpi = physIn > 0 ? Math.round((o.width || 1) / physIn) : 0;
    if (dpi < 150) {
      this.el.dpi.className = 'ds-dpi ds-dpi--warn';
      this.el.dpi.textContent = 'May print blurry — current ' + dpi + ' DPI (recommended 300). Use a larger image or shrink it.';
    } else {
      this.el.dpi.className = 'ds-dpi ds-dpi--ok';
      this.el.dpi.textContent = 'Print quality: ' + dpi + ' DPI ✓';
    }
  };

  // Filters/effects seam (e.g., future background removal) — no-op extension point.
  DesignStudio.prototype.applyFilter = function (/* name, opts */) { /* intentionally empty */ };

  DesignStudio.prototype.applyFontSize = function (px) {
    var o = this.active(); if (!o || !o.set || typeof o.fontSize === 'undefined') return;
    o.set('fontSize', parseInt(px, 10) || 28); this.fabricCanvas.requestRenderAll();
  };

  DesignStudio.prototype.applyFontFamily = function (family) {
    var o = this.active(); if (!o || typeof o.fontFamily === 'undefined') return;
    var self = this;
    o.set('fontFamily', family);
    self.fabricCanvas.requestRenderAll();
    // Ensure the web font is loaded so it renders (and exports) correctly.
    if (document.fonts && document.fonts.load) {
      try { document.fonts.load(((o.fontSize || 28)) + 'px ' + family).then(function () { self.fabricCanvas.requestRenderAll(); }); } catch (e) {}
    }
  };

  // Drive the right-hand inspector: show/hide per selected object type + reflect values.
  DesignStudio.prototype.syncToolbar = function () {
    if (this._cropping) return; // inspector is frozen while cropping
    var o = this.active();
    // Textboxes: no vertical stretch (side handles reflow width; corners scale).
    if (o && o.type === 'textbox' && o.setControlsVisibility) o.setControlsVisibility({ mt: false, mb: false });
    var hasSel = !!o && o.dsRole !== 'bg' && o.dsRole !== 'guide';
    var isText = hasSel && typeof o.fontSize !== 'undefined';
    var isImage = hasSel && o.type === 'image';
    var isShape = hasSel && !isText && !isImage;

    if (this.el.inspectorEmpty) this.el.inspectorEmpty.hidden = hasSel;
    if (this.el.inspectorBody) this.el.inspectorBody.hidden = !hasSel;
    if (this.el.inspSections) Array.prototype.forEach.call(this.el.inspSections, function (sec) {
      var f = sec.getAttribute('data-for');
      sec.hidden = !((f === 'text' && isText) || (f === 'image' && isImage) || (f === 'shape' && isShape));
    });

    var elFill = this.root.querySelector('.ds-fill[data-fill="element"]');
    if (elFill) elFill.hidden = isImage; // images render their own pixels — no solid/gradient fill
    if (o && this.el.color && typeof o.fill === 'string' && o.fill[0] === '#') this.el.color.value = o.fill;
    this.reflectElementFill(); // show Solid vs Gradient (and the gradient's colours/angle) for the selection
    if (o && this.el.strokeColor && typeof o.stroke === 'string' && o.stroke[0] === '#') this.el.strokeColor.value = o.stroke;
    if (o && this.el.strokeWidth && typeof o.strokeWidth !== 'undefined') this.el.strokeWidth.value = o.strokeWidth || 0;
    if (isText && this.el.fontSize) this.el.fontSize.value = Math.round(o.fontSize);

    var hist = this._history || [], idx = (typeof this._histIdx === 'number') ? this._histIdx : -1;
    if (this.el.btnUndo) this.el.btnUndo.disabled = idx <= 0;
    if (this.el.btnRedo) this.el.btnRedo.disabled = idx >= hist.length - 1;
    this.updateDpi();
    this.refreshClips(); // selected object shows fully; the rest are clipped to the wrap
  };

  // Clip each design object to the wrap shape, EXCEPT the currently selected one (so it's fully editable).
  DesignStudio.prototype._wrapClip = function () {
    var g = this._geo; if (!g) return null;
    return new window.fabric.Polygon(g.trap.points, { left: g.offsetX, top: g.offsetY, absolutePositioned: true });
  };
  DesignStudio.prototype.refreshClips = function () {
    var fc = this.fabricCanvas, g = this._geo; if (!fc || this._cropping) return;
    var active = fc.getActiveObject(), self = this;
    var isActive = function (o) { return o === active || (active && active._objects && active._objects.indexOf(o) !== -1); };
    this.designObjects().forEach(function (o) {
      o.clipPath = (g && !isActive(o)) ? self._wrapClip() : null;
      o.dirty = true;
    });
    fc.requestRenderAll();
  };

  DesignStudio.prototype.setMessage = function (text, isError) {
    this.el.message.textContent = text || '';
    this.el.message.classList.toggle('ds-message--error', !!isError);
  };

  /* ---- add to cart ---- */
  DesignStudio.prototype.validate = function (r) {
    if (!this.tierProducts) return 'Pricing is still loading — please try again in a moment.';
    if (this.sizeMode() === 'Custom') {
      if (!this.el.brand.value || !this.el.collection.value || !this.el.model.value || !this.el.year.value) {
        return 'Please choose your brand, collection, model and year.';
      }
      if (this.selectedClubs().length < 1) return 'Please select at least one iron.';
    } else {
      var q = parseInt(this.el.universalQty.value, 10);
      if (!q || q < 1) return 'Please enter how many wraps you want.';
    }
    if (!r || !r.variant) return 'That combination isn’t available. Try a different quantity.';
    if (!r.variant.variantId || r.variant.variantId === PLACEHOLDER) {
      return 'This product isn’t finished being set up yet (pricing products pending).';
    }
    return null;
  };

  DesignStudio.prototype.buildProperties = function (r) {
    var props = {};
    // Customer-visible confirmation that the artwork is attached. Only shown when uploads are
    // configured (production) — and a failed upload aborts add-to-cart, so it's always truthful.
    if (this.uploadConfigured()) props['Custom Graphic'] = '✓ Your design has been submitted';
    props['Club Type'] = this.clubType(); // Iron | Driver — visible so fulfillment picks the right wrap geometry
    props['Size Mode'] = this.sizeMode();
    props['Vinyl Finish'] = this.vinylFinish(); // visible in cart + on the order so fulfillment uses the right vinyl
    if (this.sizeMode() === 'Universal') {
      props['Age Group'] = this.ageGroup();
      props['Quantity'] = String(parseInt(this.el.universalQty.value, 10) || 1); // number of wraps
    } else {
      var sel = function (s) { var o = s.options[s.selectedIndex]; return o ? (o.dataset.name || o.value) : ''; };
      props['Brand'] = sel(this.el.brand);
      props['Collection'] = sel(this.el.collection);
      props['Model'] = sel(this.el.model);
      props['Year'] = sel(this.el.year);
      props['Shaft Length'] = this.el.shaft.value;
      props['Grip Length'] = this.el.grip.value;
      props['Selected Clubs'] = this.selectedClubs().join(', ');
      props['Club Count'] = String(this.selectedClubs().length);
    }
    // Design file/preview/state URLs are attached in Phase 3 (upload pipeline).
    return props;
  };

  /* ---- export + upload (Phase 3) ---- */
  DesignStudio.prototype.uuid = function () {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  };
  DesignStudio.prototype.uploadConfigured = function () {
    var u = this.config.uploadEndpoint;
    return !!u && u.indexOf('YOUR-VERCEL-APP') === -1;
  };
  DesignStudio.prototype.canvasBlob = function (multiplier /*, withBackground */) {
    var fc = this.fabricCanvas, g = this._geo;
    this.clearGuides(); // never export alignment guides
    // Export = base color + artwork, CLIPPED to the wrap shape, with guide outlines hidden,
    // and cropped tight to the wrap bounding box (no wasted working-margin pixels).
    var bg = fc.getObjects().filter(function (o) { return o.dsRole === 'bg' || o.dsRole === 'cropui'; });
    var clip = this._wrapClip(); // canvas-level clip guarantees export is clipped (even the selected object)
    bg.forEach(function (o) { o.visible = false; });
    // Export in scene space: neutralise the on-screen pan/zoom so the crop rect (scene coords)
    // captures exactly the wrap, at full resolution, regardless of the current view.
    var vpt = fc.viewportTransform;
    fc.viewportTransform = [1, 0, 0, 1, 0, 0];
    fc.clipPath = clip; fc.renderAll();
    var opts = { format: 'png', multiplier: multiplier || 1 };
    if (g) { opts.left = g.offsetX; opts.top = g.offsetY; opts.width = g.trap.widthPx; opts.height = g.trap.heightPx; }
    var dataUrl = fc.toDataURL(opts);
    fc.clipPath = null; fc.viewportTransform = vpt; bg.forEach(function (o) { o.visible = true; }); fc.renderAll();
    return this.dataUrlToBlob(dataUrl);
  };
  /* ---- 3D club preview (snippets/club-preview-modal.liquid) ---- */
  // What to show on the club. Read fresh each time: several studio changes fire no event.
  // Custom size mode still shows a standard 7-iron (owner: "an iron is an iron"); the design's
  // own length is kept because the engine sizes the wrap from the image's aspect ratio.
  DesignStudio.prototype.clubPreviewSelection = function () {
    var driver = this.clubTypeKey() === 'driver';
    var custom = !driver && this.sizeMode() === 'Custom';
    // Export tall enough to stay sharp on the shaft (~4096px, the engine's texture cap).
    var h = this._geo ? this._geo.trap.heightPx : 0;
    var mult = h ? Math.max(1, Math.min(4, 4096 / h)) : 2;
    return {
      club: driver ? 'driver' : 'iron',
      age: !custom && this.ageGroup() === 'Child' ? 'child' : 'adult',
      mode: custom ? 'custom' : 'universal',
      finish: this.vinylFinish() === 'Matte' ? 'matte' : 'gloss',
      design: this.canvasBlob(mult)
    };
  };
  DesignStudio.prototype.openClubPreview = function () {
    var msg = this.el.clubPreviewMsg;
    // A short-lived note under the button (it would go stale once they add something).
    var say = function (text) {
      if (!msg) return;
      msg.textContent = text;
      clearTimeout(msg._t);
      if (text) msg._t = setTimeout(function () { msg.textContent = ''; }, 4000);
    };
    say('');
    if (!this._geo) { say('Choose your size first.'); return; }
    if (!this.designObjects().length && !this._baseColor && !this._baseGradient) { say('Add something to the design first.'); return; }
    window.ClubPreviewModal.open(this.clubPreviewSelection());
  };
  DesignStudio.prototype.dataUrlToBlob = function (dataUrl) {
    var parts = dataUrl.split(','), mime = parts[0].match(/:(.*?);/)[1], bin = atob(parts[1]);
    var n = bin.length, arr = new Uint8Array(n);
    while (n--) arr[n] = bin.charCodeAt(n);
    return new Blob([arr], { type: mime });
  };
  // Full, restorable snapshot of the design (setup + base color + objects). Shared by
  // export (add-to-cart), local autosave, and the shareable resume link.
  DesignStudio.prototype.serializeState = function () {
    var g = this._geo;
    return {
      version: 1,
      clubType: this.clubType(),
      sizeMode: this.sizeMode(),
      ageGroup: this.sizeMode() === 'Universal' ? this.ageGroup() : null,
      universalQty: this.el.universalQty ? this.el.universalQty.value : null,
      selectedClubs: this.sizeMode() === 'Custom' ? this.selectedClubs() : [],
      selection: this.selection(),
      adjustments: this.adjustments(),
      baseColor: this._baseColor || null,
      baseGradient: this._baseGradient || null,
      vinylFinish: this.vinylFinish(),
      straightInches: g ? g.straight : null,
      pxPerInch: window.ClubWrapDimensions ? window.ClubWrapDimensions.PX_PER_INCH : 100,
      objects: this.designObjects().map(function (o) { return o.toObject(); })
    };
  };

  DesignStudio.prototype.exportDesign = function (r) {
    var g = this._geo;
    // Production raster: aim ~300 px/inch for crisp print, but clamp the output so the longest
    // side stays within the browser canvas limit (~8192px) and payloads stay sane.
    var TARGET_DPI = 300, MAX_DIM = 8192;
    var mult = 2;
    if (g && g.scale) {
      var longest = Math.max(g.trap.widthPx, g.trap.heightPx);
      mult = Math.max(1, Math.min(TARGET_DPI / g.scale, MAX_DIM / longest));
    }
    var fileBlob = this.canvasBlob(mult);            // artwork (+ base color), transparent, cropped to wrap — for printing
    var previewBlob = this.canvasBlob(2);            // small cropped thumbnail for cart/admin
    var state = this.serializeState();
    state.exportMultiplier = mult;
    state.exportDpi = g && g.scale ? Math.round(g.scale * mult) : null;
    var stateBlob = new Blob([JSON.stringify(state)], { type: 'application/json' });
    return { designId: this.uuid(), fileBlob: fileBlob, previewBlob: previewBlob, stateBlob: stateBlob };
  };

  /* ---- local autosave + restore (Phase 3) ---- */
  DesignStudio.prototype.scheduleSave = function () {
    var self = this;
    if (this._saveTimer) clearTimeout(this._saveTimer);
    this._saveTimer = setTimeout(function () { self.saveLocal(); }, 800);
  };
  DesignStudio.prototype.saveLocal = function () {
    try {
      if (!window.localStorage) return;
      var st = this.serializeState();
      // Don't persist (or wipe) an empty design — keep any prior autosave until the user
      // explicitly starts fresh or completes a cart-add.
      if (!st.objects.length && !st.baseColor) return;
      st.savedAt = Date.now();
      localStorage.setItem(this._lsKey, JSON.stringify(st));
    } catch (e) { /* quota or disabled — ignore */ }
  };
  DesignStudio.prototype.clearLocal = function () {
    try { if (window.localStorage) localStorage.removeItem(this._lsKey); } catch (e) {}
  };
  DesignStudio.prototype.designParam = function () {
    var m = /[?&]design=([^&]+)/.exec(window.location.search || '');
    return m ? decodeURIComponent(m[1]) : null;
  };
  DesignStudio.prototype.maybeRestore = function () {
    var self = this;
    var url = this.designParam();
    if (url) { // a shared resume link takes priority
      this.setMessage('Loading saved design…');
      fetch(url).then(function (r) { return r.json(); })
        .then(function (st) { self.restoreState(st); self.setMessage('Design loaded.'); })
        .catch(function () { self.setMessage('Sorry, that design link could not be loaded.', true); });
      return;
    }
    try {
      if (!window.localStorage) return;
      var raw = localStorage.getItem(this._lsKey);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (saved && ((saved.objects && saved.objects.length) || saved.baseColor)) {
        this._pendingRestore = saved;
        if (this.el.restoreBanner) this.el.restoreBanner.hidden = false;
      }
    } catch (e) { /* ignore */ }
  };
  DesignStudio.prototype.restoreState = function (state) {
    if (!state || !this.fabricCanvas) return;
    var self = this, fc = this.fabricCanvas;
    var setRadio = function (name, val) {
      var el = self.root.querySelector('input[name="' + name + '"][value="' + val + '"]');
      if (el) el.checked = true;
    };
    if (state.clubType) setRadio('ds_club_type', state.clubType);
    if (state.sizeMode) setRadio('ds_size_mode', state.sizeMode);
    this.updatePanels();
    this.rebuildTemplateOptions();
    if (state.sizeMode === 'Universal') {
      if (state.ageGroup) setRadio('ds_age_group', state.ageGroup);
      if (this.el.universalQty && state.universalQty) this.el.universalQty.value = state.universalQty;
    } else if (state.sizeMode === 'Custom') {
      var s = state.selection || {};
      if (this.el.brand && s.brandKey) { this.el.brand.value = s.brandKey; this.onBrandChange(); }
      if (this.el.collection && s.collectionKey) { this.el.collection.value = s.collectionKey; this.onCollectionChange(); }
      if (this.el.model && s.modelKey) { this.el.model.value = s.modelKey; this.onModelChange(); }
      if (this.el.year && s.year) this.el.year.value = String(s.year);
      var adj = state.adjustments || {};
      if (this.el.shaft && adj.shaftLength) this.el.shaft.value = adj.shaftLength;
      if (this.el.grip && adj.gripLength) this.el.grip.value = adj.gripLength;
      var clubs = state.selectedClubs || [];
      Array.prototype.forEach.call(this.el.clubs, function (c) { c.checked = clubs.indexOf(c.value) !== -1; });
    }
    this._baseColor = state.baseColor || null;
    this._baseGradient = state.baseGradient || null;
    if (this.el.bgColor && state.baseColor) this.el.bgColor.value = state.baseColor;
    this.reflectBgFill();
    if (state.vinylFinish) this.setVinylFinish(state.vinylFinish);
    this.refresh(); // sizes the canvas to the restored setup
    var objs = state.objects || [];
    this._suspend = true;
    this.designObjects().forEach(function (o) { fc.remove(o); });
    if (!objs.length) {
      this._suspend = false; this.reorderBackground(); fc.requestRenderAll(); this.pushHistory(); return;
    }
    window.fabric.util.enlivenObjects(objs, function (enlivened) {
      enlivened.forEach(function (o) { fc.add(o); });
      self.reorderBackground();
      self._suspend = false;
      fc.requestRenderAll();
      self.pushHistory();
      self.syncToolbar();
      if (window.document && document.fonts) document.fonts.ready.then(function () { fc.requestRenderAll(); });
    });
  };
  DesignStudio.prototype.copyText = function (text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(function () { return true; }).catch(function () { return false; });
    }
    return Promise.resolve(false);
  };
  DesignStudio.prototype.saveShareLink = function () {
    var self = this;
    if (!this.uploadConfigured()) { this.setMessage('Saving a link isn’t available right now.', true); return; }
    var st = this.serializeState();
    if (!st.objects.length && !st.baseColor && !st.baseGradient) { this.setMessage('Add something to your design first, then save a link.', true); return; }
    var id = this.uuid();
    this.el.saveLink.disabled = true;
    this.setMessage('Creating your design link…');
    var stateBlob = new Blob([JSON.stringify(st)], { type: 'application/json' });
    var previewBlob = this.canvasBlob(2);
    this.uploadBlobs([
      { key: 'state',   blob: stateBlob,   filename: 'design-' + id + '.json', mimeType: 'application/json', resource: 'FILE',  contentType: 'FILE' },
      { key: 'preview', blob: previewBlob, filename: 'preview-' + id + '.png', mimeType: 'image/png',        resource: 'IMAGE', contentType: 'IMAGE' }
    ], id).then(function (urls) {
      var link = window.location.origin + window.location.pathname + '?design=' + encodeURIComponent(urls.state);
      return self.copyText(link).then(function (ok) {
        self.setMessage(ok ? 'Link copied! Paste it anywhere to resume your design.' : ('Your resume link: ' + link));
      });
    }).catch(function () {
      self.setMessage('Sorry, we couldn’t create a link. Please try again.', true);
    }).then(function () { self.el.saveLink.disabled = false; });
  };
  // Staged upload of an arbitrary set of blobs → returns a { key: permanentUrl } map.
  DesignStudio.prototype.uploadBlobs = function (specs, id) {
    var endpoint = this.config.uploadEndpoint;
    var post = function (bodyObj) {
      return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(bodyObj) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok || j.error) throw new Error(JSON.stringify(j.error || j)); return j; }); });
    };
    // 1) stage
    return post({ step: 'stage', files: specs.map(function (s) { return { key: s.key, filename: s.filename, mimeType: s.mimeType, fileSize: s.blob.size, resource: s.resource }; }) })
      .then(function (stageRes) {
        var targets = {};
        (stageRes.targets || []).forEach(function (t) { targets[t.key] = t; });
        // 2) upload each binary directly to its staged target
        return Promise.all(specs.map(function (s) {
          var t = targets[s.key];
          var fd = new FormData();
          (t.parameters || []).forEach(function (p) { fd.append(p.name, p.value); });
          fd.append('file', s.blob, s.filename);
          return fetch(t.url, { method: 'POST', body: fd }).then(function (up) {
            if (!up.ok) throw new Error('Staged upload failed for ' + s.key + ' (' + up.status + ')');
            return { key: s.key, resourceUrl: t.resourceUrl, filename: s.filename, mimeType: s.mimeType, contentType: s.contentType, alt: 'Design ' + id };
          });
        }));
      })
      .then(function (regInputs) { return post({ step: 'register', files: regInputs }); })
      .then(function (regRes) {
        var urls = {};
        (regRes.files || []).forEach(function (f) { urls[f.key] = f.url; });
        return urls;
      });
  };
  DesignStudio.prototype.uploadDesign = function (exported) {
    var id = exported.designId;
    return this.uploadBlobs([
      { key: 'file',    blob: exported.fileBlob,    filename: 'design-' + id + '.png',  mimeType: 'image/png',        resource: 'IMAGE', contentType: 'IMAGE' },
      { key: 'preview', blob: exported.previewBlob, filename: 'preview-' + id + '.png', mimeType: 'image/png',        resource: 'IMAGE', contentType: 'IMAGE' },
      { key: 'state',   blob: exported.stateBlob,   filename: 'design-' + id + '.json', mimeType: 'application/json', resource: 'FILE',  contentType: 'FILE' }
    ], id).then(function (urls) {
      return { fileUrl: urls.file, previewUrl: urls.preview, stateUrl: urls.state, designId: id };
    });
  };

  /* ---- add to cart ---- */
  DesignStudio.prototype.addToCart = function () {
    var self = this;
    var r = this.resolve();
    var err = this.validate(r);
    if (err) { this.setMessage(err, true); return; }
    // Required rights confirmation (Terms of Service: customer designs). Stored on the order as proof.
    if (this.el.rights && !this.el.rights.checked) {
      this.setMessage('Please confirm you own or have permission to use everything in your design.', true);
      this.el.rights.focus();
      return;
    }

    this.el.addToCart.disabled = true;
    var props = this.buildProperties(r);
    if (this.el.rights) props['_Rights confirmed'] = new Date().toISOString();

    var ensureArtwork = Promise.resolve();
    if (this.uploadConfigured()) {
      this.setMessage('Saving your design…');
      ensureArtwork = Promise.resolve()
        .then(function () { return self.uploadDesign(self.exportDesign(r)); })
        .then(function (up) {
          if (!up.fileUrl) throw new Error('design file did not return a URL');
          // Leading "_" hides these internal URLs from the customer in cart/checkout
          // (still stored on the order; the fulfillment processor reads the same names).
          props['_Design File'] = up.fileUrl;
          if (up.previewUrl) props['_Design Preview'] = up.previewUrl;
          if (up.stateUrl) props['_Design State'] = up.stateUrl;
          props['_design_id'] = up.designId;
        });
    } else {
      console.warn('[design-studio] uploadEndpoint not configured — adding to cart WITHOUT artwork (dev mode).');
    }

    ensureArtwork
      .then(function () {
        self.setMessage('Adding to cart…');
        var form = new FormData();
        form.append('id', r.variant.variantId);
        form.append('quantity', '1'); // count is encoded in the variant
        Object.keys(props).forEach(function (k) { form.append('properties[' + k + ']', props[k]); });
        return fetch('/cart/add.js', { method: 'POST', body: form });
      })
      .then(function (res) {
        if (!res.ok) return res.text().then(function (t) {
          var msg = t;
          try { var j = JSON.parse(t); msg = j.description || j.message || t; } catch (e2) {}
          throw new Error(msg || ('HTTP ' + res.status));
        });
        return res.json();
      })
      .then(function () { self.clearLocal(); window.location.href = '/cart'; })
      .catch(function (e) {
        self.el.addToCart.disabled = false;
        self.setMessage('Could not add to cart: ' + (e.message || e), true);
      });
  };

  ready(function () {
    var root = document.getElementById('design-studio-root');
    if (!root) return;
    try {
      new DesignStudio(root, window.designStudioConfig || {});
    } catch (e) {
      // Surface init failures instead of silently disabling the studio.
      console.error('Design studio failed to initialize:', e);
      var msg = root.querySelector('#ds-message');
      if (msg) { msg.textContent = 'Design studio error: ' + (e && e.message ? e.message : e); msg.classList.add('ds-message--error'); }
    }
  });
})();
